import React, { useEffect, useMemo, useRef, useState } from 'react';
import services from '../../services';
import AppModal from '../../common/AppModal';
import { FiZap, FiPlus, FiSave, FiCheck, FiMenu } from 'react-icons/fi';
import '../UserManage/User.css';
import { toast } from 'react-toastify';
import { GET_ALL_USER } from '../../utils/Apifunction';
import AppSelect from '../../common/AppSelect';

import Select, { components } from 'react-select';
import { getLocalStorageItem, removeLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';
import labelService from '../../services/labelService';
import StatusDropdown from '../Task/StatusDropdown';
import AutomationStatusDropdown from './AutomationStatusSelectDropdown';
import { getEffectivePrivileges } from '../../utils/normalizeKey';
import PropertyStatusLinkForm, { PROPERTY_STATUS_LINK_TYPE } from './PropertyStatusLinkForm';
import ListProcessForm, { LIST_PROCESS_TYPE } from './ListProcessForm';
import TicketPriorityForm, { TICKET_PRIORITY_TYPE } from './TicketPriorityForm';
import ChecklistItemAction, { hasChecklistItemAction } from './ChecklistItemAction';
import { ORDER_OPTIONAL, OrderRuleRadio, OrderBadge, orderModeOf, orderFlagsFromSaved, orderPayload } from './ChecklistOrder';
import EditorComponent from '../Template/Editor';

// Language "auto": the server sends the template in the language the customer writes in (English when unknown)
const AUTO_LANGUAGE = 'auto';
const AUTO_LANGUAGE_OPTION = { value: AUTO_LANGUAGE, label: 'Auto (customer email language)' };
// Template language columns sometimes hold the text "null"
const txt = (v) => {
    const s = v == null ? '' : String(v);
    return s.trim() === 'null' || s.trim() === 'undefined' ? '' : s;
};

// "No reply from customer" email sequence: the first email + up to 3 more
const FOLLOW_UP_NAMES = ['2nd follow-up', '3rd follow-up', 'Final follow-up'];
const FOLLOW_UP_UNITS = [
    { value: 'mins', label: 'minutes' },
    { value: 'hours', label: 'hours' },
    { value: 'days', label: 'days' },
];

// The saved email body can come back HTML-escaped (&lt;div&gt;...), which the editor would
// show as literal text. Only decode when escaped tags are present and no real tags are, and
// repeat to cover double-escaping.
const decodeEscapedHtml = (html = '') => {
    let out = html || '';
    for (let i = 0; i < 3 && /&(amp;)*lt;\/?[a-z]/i.test(out) && !/<\/?[a-z][^>]*>/i.test(out); i++) {
        const el = document.createElement('textarea');
        el.innerHTML = out;
        if (el.value === out) break;
        out = el.value;
    }
    return out;
};

// "Item added / moved to a list" actions run for tickets coming from the left list(s), the right list(s), or both.
// right = the ticket moved forward (from a list on the left), left = it moved back (from a list on the right).
// Automations saved before this option have no directions = both.
const MOVE_DIRECTIONS = ['right', 'left'];
const normalizeDirections = (directions) => {
    const valid = Array.isArray(directions) ? directions.filter((d) => MOVE_DIRECTIONS.includes(d)) : [];
    return valid.length ? [...new Set(valid)] : [...MOVE_DIRECTIONS];
};

// Saved checklist item; checksBelow = ticking it on the ticket also ticks every item below it,
// onCheck = ticking it moves the ticket / sets a property
// orderMode: the automation's own checklist only — inOrder = must be checked in order (lock icon)
const toChecklistPayload = (item, orderMode) => ({
    label: item.text.trim(),
    value: !!item.checked,
    ...orderPayload(item, orderMode),
    ...(item.checksBelow ? { checksBelow: true } : {}),
    ...(hasChecklistItemAction(item.onCheck) ? { onCheck: item.onCheck } : {}),
});

const Automation = ({
    onHide,
    show,
    boardName,
    gmailUsers,
    editData,
    editId,
    getAllAutomation,
    setStep,
    setAutomations,
    setEditId,
}) => {
    const [boardSelect, setBoardSelect] = useState('');
    const [boardColumnSelect, setBoardColumnSelect] = useState('');
    const [selectGmailUser, setSelectGmailUser] = useState('');
    const [rule, setRule] = useState('');
    const [userSelect, setUserSelect] = useState('');
    const [activeTab, setActiveTab] = useState('Gmail');
    const [allClient, setAllClient] = useState([]);
    const [editDatas, setEditDatas] = useState(null);
    const [userData, setUserData] = useState([]);
    const [boardUsers, setBoardUsers] = useState([]);
    const [boardUsersByBoard, setBoardUsersByBoard] = useState({});
    const [boardUsersLoading, setBoardUsersLoading] = useState(false);
    const [boardUsersLoadingBoardId, setBoardUsersLoadingBoardId] = useState(null);
    const [selectedBoardColumn, setSelectedBoardColumn] = useState([]);
    const [automationsData, setAutomationsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [duplicateMsg, setDuplicateMsg] = useState('');
    const [selectedType, setSelectedType] = useState();
    const [customPropertyOptions, setCustomPropertyOptions] = useState([]);
    const [boardError, setBoardError] = useState('');
    const [customFieldOptionsByRow, setCustomFieldOptionsByRow] = useState({});
    const [selectedCustomFieldByRow, setSelectedCustomFieldByRow] = useState({});
    const [customFieldLoadingByRow, setCustomFieldLoadingByRow] = useState({});
    const [customFieldErrorByRow, setCustomFieldErrorByRow] = useState({});
    const [runOnExistingEmails, setRunOnExistingEmails] = useState(false);
    const [days, setDays] = useState(1);
    const [checklistByRow, setChecklistByRow] = useState({});
    const [showChecklist, setShowChecklist] = useState(false);
    // Mandatory checklist: a ticket cannot leave the list until every item is checked
    const [checklistMandatory, setChecklistMandatory] = useState(false);
    const [checklistOrder, setChecklistOrder] = useState(ORDER_OPTIONAL);
    const [checklistEnabledByRow, setChecklistEnabledByRow] = useState({});
    const [templateOptions, setTemplateOptions] = useState([]);

    useEffect(() => {
        const loadTemplates = async () => {
            try {
                const query = new URLSearchParams();
                query.append('falsePagination', true);
                const response = await services.template.GET_ALL_TEMPLATE(query);

                let storedData = {};
                try {
                    const parsedOnce = JSON.parse(localStorage.getItem('userData'));
                    storedData = typeof parsedOnce === 'string' ? JSON.parse(parsedOnce) : parsedOnce || {};
                } catch (err) {
                    console.error('Parsing error:', err);
                }
                const role = storedData?.role?.toLowerCase();
                const privileges = storedData?.privileges || getEffectivePrivileges(storedData);
                const allowedFolders = privileges?.emailTemplateFolders || [];

                let list = (response?.templates || []).filter((item) => item.status === true);
                if (role !== 'admin') {
                    list = list.filter((item) => !item.folderId || allowedFolders.includes(item.folderId));
                }
                setTemplateOptions(list.map((item) => ({
                    label: item.name || '',
                    value: item.id,
                    languages: {
                        English: { subject: txt(item.subject), body: txt(item.body) },
                        French: { subject: txt(item.frenchSubject), body: txt(item.frenchBody) },
                        German: { subject: txt(item.germanSubject), body: txt(item.germanBody) },
                        Portuguese: { subject: txt(item.portugueseSubject), body: txt(item.portugueseBody) },
                        Spanish: { subject: txt(item.spanishSubject), body: txt(item.spanishBody) },
                    },
                })));
            } catch (e) {
                console.error(e);
                setTemplateOptions([]);
            }
        };
        loadTemplates();
    }, []);


    useEffect(() => {
        const getProperties = async () => {
            if (!boardSelect) {
                setCustomPropertyOptions([]);
                return;
            }

            try {
                const response = await services.property.GET_PROPERTY_BY_BOARD_ID(boardSelect);
                const options = (response?.data?.data || []).map((prop) => ({
                    label: prop.property.propertyName,
                    value: prop.id,
                }));

                setCustomPropertyOptions(options);
            } catch (error) {
                console.error(error);
                setCustomPropertyOptions([]);
            }
        };

        getProperties();
    }, [boardSelect]);

    const conditionOptions = [
        { label: 'the subject', value: 'subject' },
        { label: 'the From email address', value: 'sender' },
        { label: 'the To email address', value: 'recipient' },
    ];
    const operatorOptions = [
        { label: 'contains', value: 'contains' },
        { label: 'does not contain', value: 'doesNotContain' },
        { label: 'is', value: 'equals' },
    ];
    const completedConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'sender' },
        { label: "the customer's email address", value: 'recipient' },
        { label: 'assignee', value: 'assignee' },
    ];
    const ConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'recipient' },

        { label: 'assignee', value: 'assignee' },
    ];
    const [actionRows, setActionRows] = useState([{ action: '', order: '', boardId: '', entityId: '' }]);

    const initialActionRow = { action: '', order: '', boardId: '', entityId: '', user: '' };

    const initialCondition = {
        field: conditionOptions[0]?.value || '',
        operator: operatorOptions[0]?.value || '',
        value: '',
    };

    const sla_alert_action = [
        {
            label: '🔥 SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 bg-pink-100',
        },
        {
            label: '⚡ SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 bg-orange-100',
        },
    ];

    const MultiValue = (props) => {
        const className = props.data.className || '';
        return (
            <div className={`flex items-center rounded-md px-2 py-1 mr-1 mb-1 text-sm ${className}`}>
                <span className="mr-1">{props.data.label}</span>
                <components.MultiValueRemove {...props}>
                    <span {...props.removeProps} className="ml-1 text-red-500 hover:text-red-700 cursor-pointer">
                        ×
                    </span>
                </components.MultiValueRemove>
            </div>
        );
    };

    const Option = (props) => {
        const { className = '', label } = props.data;
        return (
            <components.Option {...props}>
                <div className={`text-sm rounded-md px-2 py-1 w-[120px] ${className}`}>{label}</div>
            </components.Option>
        );
    };

    const CheckboxOption = (props) => {
        const { isSelected, label } = props;
        return (
            <components.Option {...props}>
                <div className="flex items-center gap-2 py-1 text-sm">
                    <input
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                        style={{ accentColor: '#1a7d3e', width: '15px', height: '15px', flexShrink: 0, cursor: 'pointer' }}
                    />
                    <span style={{ color: isSelected ? '#1a7d3e' : '#1f2937', fontWeight: isSelected ? 600 : 400 }}>
                        {label}
                    </span>
                </div>
            </components.Option>
        );
    };

    const customStyles = {
        control: (styles, { isFocused }) => ({
            ...styles,
            minHeight: '38px',
            borderRadius: '6px',
            border: '1px solid #d1d5db',
            boxShadow: 'none',
            outline: 'none',
            backgroundColor: '#fff',
            '&:hover': { borderColor: '#d1d5db' },
        }),
        input: (styles) => ({
            ...styles,
            caretColor: 'transparent',
            width: 0,
            minWidth: 0,
        }),
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.color || '#f3f4f6',
            borderRadius: '6px',
            padding: '2px 4px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            fontSize: '0.875rem',
            color: '#111827',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#ef4444',
            ':hover': {
                backgroundColor: '#fecaca',
                color: '#b91c1c',
            },
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (styles) => ({ ...styles, color: '#6b7280', padding: '0 8px' }),
        menu: (styles) => ({ ...styles, borderRadius: '8px', boxShadow: '0 6px 16px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', zIndex: 9999 }),
        option: (styles, state) => ({
            ...styles,
            fontSize: '13px',
            backgroundColor: state.isSelected ? '#f0fdf4' : state.isFocused ? '#f5faf6' : 'transparent',
            color: '#1f2937',
            cursor: 'pointer',
        }),
    };

    const formattedOptions = sla_alert_action.map((item) => ({
        label: `# ${item.label}`,
        value: item.value,
        className: item.color || '',
    }));


    const defaultMailConditions = [{ field: 'title', operator: 'equals', value: '' }];

    const defaultNoReplyToCustomerConditions = [{ field: 'customerWaiting', operator: 'moreThanMins', value: '' }];
    const defaultNoReplyFromCustomerConditions = [
        { field: 'customerNotResponding', operator: 'moreThanMins', value: '' },
    ];
    const [conditions, setConditions] = useState([initialCondition]);

    // Boards with a ticket process only accept some lists: { entry, sameBoard } = allowed lists per board for a ticket
    // coming from another board / new, and for a ticket in this rule's list (moves on the rule's own board)
    const [processAllowed, setProcessAllowed] = useState({ entry: {}, sameBoard: {} });
    const ruleListId = conditions.find((c) => c?.field === 'listName')?.value || '';
    useEffect(() => {
        if (!show) return;
        let cancelled = false;
        (async () => {
            try {
                const [entry, sameBoard] = await Promise.all([
                    services.automations.LIST_PROCESS_ALLOWED(),
                    boardSelect
                        ? services.automations.LIST_PROCESS_ALLOWED({ fromBoardId: boardSelect, fromListId: ruleListId })
                        : Promise.resolve({}),
                ]);
                if (!cancelled) setProcessAllowed({ entry, sameBoard });
            } catch (e) {
                console.error(e);
            }
        })();
        return () => { cancelled = true; };
    }, [show, boardSelect, ruleListId]);
    const processOf = (boardId) =>
        (boardId && boardId === boardSelect && selectedType !== 'new' ? processAllowed.sameBoard : processAllowed.entry)[boardId] || null;
    // List options of a "create / move to list" action: only the lists the board's ticket process allows
    const targetListOptions = (boardId, currentListId) => {
        const all = selectedBoardColumn.map((item) => ({ value: item.id, label: item.coloum }));
        const process = processOf(boardId);
        if (!process) return all;
        return all.filter((o) => o.value === currentListId || process.allowedListIds.includes(o.value));
    };

    const [syncGmail, setSyncGmail] = useState([]);
    const [selectedMailUser, setSelectedMailUser] = useState();
    const [showAction, setShowAction] = useState();
    const [actions, setActions] = useState(false);
    const [skipInbox, setSkipInbox] = useState(false);
    const [skipReplies, setSkipReplies] = useState(true);
    const [runOnExisting, setRunOnExisting] = useState(false);
    const [existingDays, setExistingDays] = useState('1');
    const [lables, setLables] = useState([]);
    const [preselectedLoaded, setPreselectedLoaded] = useState({});



    useEffect(() => {
        if (show && !editId) {
            setBoardSelect('');
            setBoardColumnSelect('');
            setSelectGmailUser('');
            setRule('');
            setUserSelect('');
            setEditDatas(null);
            setChecklistByRow({});
            setShowChecklist(false);
            setChecklistMandatory(false);
            setChecklistOrder(ORDER_OPTIONAL);

            removeLocalStorageItem('editGmailUserId')
        }
    }, [show, editId]);

    useEffect(() => {
        if (editDatas && selectedBoardColumn && selectedBoardColumn.length > 0 && editDatas?.condition?.boardListId) {
            setBoardColumnSelect(editDatas?.condition?.boardListId);

        }
    }, [selectedBoardColumn, editDatas]);

    useEffect(() => {
        if (boardSelect) {
            getSELECTED_BOARD(boardSelect);
            GET_BOARD_USER_DATA(boardSelect);
        } else {
            setBoardUsers([]);
        }
    }, [boardSelect]);

    const GET_BOARD_USER_DATA = async (boardId) => {
        if (!boardId) {
            setBoardUsers([]);
            setBoardUsersLoading(false);
            setBoardUsersLoadingBoardId(null);
            return;
        }

        if (boardUsersByBoard[boardId]) {
            setBoardUsers(boardUsersByBoard[boardId]);
            return;
        }

        setBoardUsersLoading(true);
        setBoardUsersLoadingBoardId(boardId);

        try {
            const falsePagination = true;
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(boardId, '', falsePagination);
            const allData = response?.data?.data || [];
            const uniqueUsers = Array.from(
                new Map(
                    allData.map((item) => {
                        const user = item?.User || item;
                        return [user?.id || item.userId || item.id, user];
                    }),
                ).values(),
            );
            setBoardUsers(uniqueUsers);
            setBoardUsersByBoard((prev) => ({ ...prev, [boardId]: uniqueUsers }));
        } catch (error) {
            console.error(error);
            setBoardUsers([]);
        } finally {
            setBoardUsersLoading(false);
            setBoardUsersLoadingBoardId(null);
        }
    };

    const getAllAutomationData = async () => {
        setLoading(true);
        try {
            const response = await services.automations.GET_ALL_AUTOMATIONS();

            if (response) {
                setAutomationsData(response);
            }
        } catch (e) {
            toast.error('Failed to fetch automations');
        }
        setLoading(false);
    };


    const LablesName = async () => {
        const response = await labelService.GET_Label_ALL();

        setLables(response?.data?.labels)
    }

    useEffect(() => {
        getAllAutomationData();
        LablesName();
    }, []);


    const handleLabelChange = (i, value) => {

        if (!value) return updateUser(i, null);

        try {
            const selected = JSON.parse(value);
            updateUser(i, {
                id: selected.childId,
                name: selected.name,
                parentId: selected.parentId || undefined,
            });
        } catch (e) {
            console.error('Error parsing label:', e);
        }
    };




    const getSELECTED_BOARD = async (boardSelect) => {
        try {
            const { data } = await services.board.SELECTED_BOARD(boardSelect);
            const sortedData = (data || [])
                .slice()
                .sort((a, b) => Number(a.sequence) - Number(b.sequence));
            setSelectedBoardColumn(sortedData);
            setBoardColumnSelect('');
        } catch (e) {
            console.error(e);
        }
    };
    const handleCreate = async () => {
        // "When checked" actions of checklist items: board needs a list, property needs a status
        if (showChecklist) {
            const badItem = (checklistByRow['default'] || []).find((item) => {
                const a = item.text.trim() && item.onCheck;
                if (!a) return false;
                const fieldCount = Array.isArray(a.customField) ? a.customField.length : 0;
                return (a.boardId && !a.listId) || (a.customProperty && !fieldCount);
            });
            if (badItem) {
                toast.error(`Task "${badItem.text.trim()}": when checked — select the list, and a status for the property`);
                return;
            }
        }
        const emailRow = actionRows.find((r) => r.action === 'sendEmailToCustomer' && !(r.body || '').trim());
        if (emailRow) {
            toast.error('Please select a template or enter the email body');
            return;
        }
        if (selectedType === 'noReplyFromCustomer') {
            for (const r of actionRows.filter((row) => row.action === 'sendEmailToCustomer')) {
                const bad = (r.followUps || []).findIndex((f) => !(Number(f.after?.value) > 0) || !(f.body || '').trim());
                if (bad !== -1) {
                    toast.error(`${FOLLOW_UP_NAMES[bad] || 'Follow-up'}: enter the waiting time and the email body`);
                    return;
                }
            }
        }
         // A "Set custom property" action must use a property of the selected board
        const wrongPropertyRow = actionRows.find((r) => {
            if (r.action !== 'setCustomProperty') return false;
            const propId = r.user || r.customPropertyId || r.propertyId || '';
            return !propId || !customPropertyOptions.some((o) => o.value === propId);
        });
        if (wrongPropertyRow) {
            toast.error('Please select a property of this board for the "Set custom property" action');
            return;
        }
        // Every "moved to a list" action must run in at least one direction
        if (selectedType === 'itemAdded') {
            const noDirectionIndex = actionRows.findIndex((r) => r.action && Array.isArray(r.directions) && r.directions.length === 0);
            if (noDirectionIndex !== -1) {
                toast.error(`Action ${noDirectionIndex + 1}: tick at least one direction (moved forward and/or moved back)`);
                return;
            }
        }
        const payload = buildPayload();

        try {
            const response = !editId
                ? await services.automations.CREATE_AUTOMATIONS(payload)
                : await services.automations.UPDATE_AUTOMATIONS(editId, payload);
            if (response) {
                toast.success(editId ? 'Automations Updated Successfully' : 'Automations Added Successfully');
                setStep(1);
                getAllAutomation && getAllAutomation();

                removeLocalStorageItem('editGmailUserId')
            }
        } catch (e) {
            console.error(e);
        }
    };

    const addCondition = () => {
        const validConditions = Array.isArray(conditions) ? conditions : [];

        let availableOptions = [];

        if (selectedType === 'new') {
            availableOptions = conditionOptions;
        } else if (selectedType === 'itemAdded') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyToCustomer') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyFromCustomer') {
            availableOptions = completedConditionOptions;
        }

        if (availableOptions.length === 0) return;

        const defaultField = availableOptions[0]?.value || '';
        let defaultOperator = operatorOptions[0]?.value || '';


        if (defaultField === 'assignee') {
            defaultOperator = 'equals';
        } else if (defaultField === 'customerWaiting' || defaultField === 'customerNotResponding') {
            defaultOperator = 'moreThanMins';
        }

        setConditions((prev) =>
            Array.isArray(prev)
                ? [
                    ...prev,
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ]
                : [
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ],
        );
    };

    const removeCondition = (index) => {
        const updated = conditions.filter((_, i) => i !== index);
        setConditions(updated);
    };

    const conditionThenOption = [


        { label: 'move it to the specific list', value: 'createOnList' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'assign it to', value: 'assignTo' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' }


    ];
    const getEditData = async (editId) => {
        try {
            const response = await services.automations.GET_BY_ID_AUTOMATIONS(editId);
            if (response && response.data && response.data.data) {
                const automation = response.data.data;

                setConditions([]);
                // Reset checklist state so a stale checklist from a previously
                // opened automation doesn't leak into this one when it has none.
                setShowChecklist(false);
                setChecklistByRow({});
                setChecklistEnabledByRow({});
                setChecklistMandatory(!!automation?.checklistMandatory);

                setSelectedType(automation?.type);
                setRule(automation?.name);

                const nonEmptyDefaultChecklist = Array.isArray(automation?.checklist)
                    ? automation.checklist.filter((item) => (item?.label || '').trim())
                    : [];
                const savedOrder = orderModeOf(nonEmptyDefaultChecklist);
                setChecklistOrder(savedOrder);
                if (nonEmptyDefaultChecklist.length > 0) {
                    setChecklistByRow(prev => ({
                        ...prev,
                        default: nonEmptyDefaultChecklist.map((item, ci) => ({
                            id: `default-${ci}`,
                            text: item.label,
                            checked: !!item.checked,
                            ...orderFlagsFromSaved(item, savedOrder),
                            checksBelow: !!item.checksBelow,
                            onCheck: item.onCheck,
                        })),
                    }));
                    setShowChecklist(true);
                }
                const emailResponse = await services.email.Get_The_Linked_Email();
                const formattedOptions =
                    emailResponse?.data?.map((item) => ({
                        value: item.id,
                        label: item.email,
                    })) || [];

                setSyncGmail(formattedOptions);

                if (automation?.type === 'new' && automation?.when?.gmailUserId) {
                    const matchedUser = formattedOptions.find((user) => user.value === automation.when.gmailUserId);
                    if (matchedUser) {
                        setSelectedMailUser(matchedUser);
                    }
                }

                const userConditions = automation.condition.filter((cond) => {
                    // ❌ Hide board auto-generated conditions
                    if (
                        cond.operand === 'board' &&
                        (automation?.type === 'itemAdded' ||
                            automation?.type === 'noReplyToCustomer' ||
                            automation?.type === 'noReplyFromCustomer')
                    ) {
                        return false;
                    }

                    // ❌ Hide the existingInboxMails condition from the UI
                    if (cond.operand === 'existingInboxMails') {
                        return false;
                    }

                    return true;
                });


                setConditions(
                    userConditions.map((cond) => ({
                        field: cond.operand,
                        operator: cond.operator,
                        value:
                            cond.operand === 'assignee' && Array.isArray(cond.value)
                                ? cond.value[0]?.entityId || ''
                                : cond.value,
                    })),
                );

                let boardId = null;
                if (automation?.type === 'new') {
                    const createOnListAction = automation.action.find((a) => a.action === 'createOnList');
                    if (createOnListAction) {
                        boardId = createOnListAction.boardId;
                    }
                } else {
                    const boardCondition = automation.condition.find((cond) => cond.operand === 'board');
                    if (boardCondition) {
                        boardId = boardCondition.value;
                    }
                }

                if (boardId) {
                    setBoardSelect(boardId);

                    getSELECTED_BOARD(boardId);
                }

                const customPropertyToFetch = [];
                const mainActions = automation.action
                    .filter((a) => a.action !== 'subEmailInbox' && a.action !== 'emailInbox')
                    .map((action, i) => {

                        const mappedAction = {
                            action: action.action,
                            order: action.order,
                            directions: normalizeDirections(action.directions),
                            customField: action.customField ?? undefined,
                            customProperty: action.customProperty ?? undefined,
                            user: action.action === 'setCustomProperty' ? action.customProperty ?? '' : undefined
                        };

                        if (action.action === 'setCustomProperty') {
                            mappedAction.customProperty = action.customProperty ?? '';
                            mappedAction.onConflict = action.onConflict || 'keep';
                            mappedAction.reverse = !!action.reverse;

                            mappedAction.customField = Array.isArray(action.customField) ? action.customField : [];
                            mappedAction.user = action.customProperty ?? '';
                            if (Array.isArray(action.customField) && action.customField.length > 0) {
                                setSelectedCustomFieldByRow(prev => ({
                                    ...prev,
                                    [i]: action.customField.map(cf => ({
                                        id: cf.id,
                                        label: cf.label,
                                        color: cf.color
                                    }))
                                }));


                            }

                            if (action.action === 'setCustomProperty' && action.customProperty) {
                                mappedAction.propertyId = action.customProperty;
                                customPropertyToFetch.push({ index: i, propertyId: action.customProperty });
                            }

                            const nonEmptyRowChecklist = Array.isArray(action.checklist)
                                ? action.checklist.filter((item) => (item?.label || '').trim())
                                : [];
                            if (nonEmptyRowChecklist.length > 0) {
                                setChecklistByRow(prev => ({
                                    ...prev,
                                    [i]: nonEmptyRowChecklist.map((item, ci) => ({
                                        id: `${i}-${ci}`,
                                        text: item.label,
                                        checked: !!item.checked,
                                        checksBelow: !!item.checksBelow,
                                        onCheck: item.onCheck,
                                    })),
                                }));
                                setChecklistEnabledByRow(prev => ({ ...prev, [i]: true }));
                            }

                        }
                        if (action.action === 'createOnList') {
                            mappedAction.boardId = action.boardId;
                            mappedAction.entityId = action.entityId;
                        } else if (['assignTo', 'unassign'].includes(action.action)) {
                            mappedAction.user = action.entityId;
                        } else if (action.action === 'assignToRoundRobin') {
                            mappedAction.users =
                                action.entityIds?.map((e) => ({
                                    value: e.entityId,
                                    label: e.name,
                                })) || [];
                        } else if (action.action === 'setSlaAlertTag') {
                            mappedAction.entityId = action.entityValue;
                        } else if (action.action === 'sendEmailToCustomer') {
                            mappedAction.templateId = action.templateId;
                            // a template saved without a language is sent in the customer's language
                            mappedAction.language = action.language || (action.templateId ? AUTO_LANGUAGE : '');
                            mappedAction.subject = action.subject || '';
                            mappedAction.body = decodeEscapedHtml(action.body);
                            mappedAction.followUps = (Array.isArray(action.followUps) ? action.followUps : []).map((f) => ({
                                after: { value: f?.after?.value != null ? String(f.after.value) : '', unit: f?.after?.unit || 'days' },
                                templateId: f?.templateId || '',
                                language: f?.language || (f?.templateId ? AUTO_LANGUAGE : ''),
                                subject: f?.subject || '',
                                body: decodeEscapedHtml(f?.body),
                            }));
                        } else if (action.action === 'sendFollowUpToCustomer') {
                            mappedAction.message = action.templateHtml;
                        } else if (
                            ['sendOverdueAlert', 'sendUpcomingAlert', 'sendNotificationTo'].includes(action.action)
                        ) {
                            mappedAction.entityId = action.entityId;
                            mappedAction.message = action.entityValue;
                        } else if (action.action === 'moveToNextList') {

                            mappedAction.action = 'moveToNext';
                        } else if (action.action === 'moveToPreviousList') {

                            mappedAction.action = 'moveToPreviousList';
                        }


                        else if (action.action === 'setEmailLabel') {
                            const findDeepLabel = (nodes, { parentId = null, labelName }) => {
                                const findNodeById = (list, id) => {
                                    for (const n of list || []) {
                                        if (n.id === id) return n;
                                        if (n.children) {
                                            const found = findNodeById(n.children, id);
                                            if (found) return found;
                                        }
                                    }
                                    return null;
                                };

                                const findDeepInSubtree = (root, name) => {
                                    let best = null;
                                    const dfs = (node, parent) => {
                                        if (node.name === name) {
                                            best = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                        }
                                        if (node.children) {
                                            for (const child of node.children) dfs(child, node);
                                        }
                                    };
                                    dfs(root, null);
                                    return best;
                                };

                                if (parentId) {
                                    const ancestor = findNodeById(nodes, parentId);
                                    if (!ancestor) return null;
                                    return findDeepInSubtree(ancestor, labelName);
                                }

                                let deepest = null;
                                const dfsAll = (node, parent) => {
                                    if (node.name === labelName) {
                                        deepest = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                    }
                                    if (node.children) {
                                        for (const child of node.children) dfsAll(child, node);
                                    }
                                };
                                for (const n of nodes || []) dfsAll(n, null);
                                return deepest;
                            };

                            const matchedLabel = findDeepLabel(lables, {
                                parentId: action.parentId || null,
                                labelName: action.labelName,
                            });

                            mappedAction.user = matchedLabel || {
                                id: null,
                                name: action.labelName,
                                parentId: action.parentId || null,
                            };
                        }




                        else if (action.action === 'markComplete') {
                            mappedAction.action = 'markComplete';
                        } else if (action.action === 'markIncomplete') {
                            mappedAction.action = 'markIncomplete';
                        }

                        return mappedAction;
                    });

                setActionRows(mainActions);
                if (automation?.type === 'new') {
                    const subEmailInboxAction = automation.action.find((a) => a.action === 'subEmailInbox');
                    const emailInboxAction = automation.action.find((a) => a.action === 'emailInbox');
                    setSkipReplies(subEmailInboxAction ? subEmailInboxAction.isProcessed : false);
                    setSkipInbox(emailInboxAction ? emailInboxAction.hasReply : false);
                }
                if (automation?.condition) {
                    const emailInboxAction = automation.condition.find((a) => a.operand === 'existingInboxMails');
                    if (emailInboxAction?.value) {
                        setDays(emailInboxAction?.value);
                    }
                    if (emailInboxAction?.operand == "existingInboxMails") {
                        setRunOnExistingEmails(true);
                    }
                }

                // Fetch custom property options for each row
                for (const item of customPropertyToFetch) {
                    await handlePropertySelect(item.index, item.propertyId);
                }

            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (!editId || !lables?.length) return;
        getEditData(editId);
    }, [editId, lables]);


    useEffect(() => {
        if (editId) {
            getEditData(editId);
        }
    }, [editId]);

    useEffect(() => {
        if (editId && syncGmail.length > 0 && selectedType === 'new') {

            const storedGmailUserId = getLocalStorageItem('editGmailUserId')
            if (storedGmailUserId) {
                const gmailUser = syncGmail.find((user) => user.value === storedGmailUserId);
                if (gmailUser) {
                    setSelectedMailUser(gmailUser);
                }
            }
        }
    }, [syncGmail, editId, selectedType]);


    useEffect(() => {
        GET_ALL_USER_DATA();
        GET_ALL_Whastpp_DATA();
    }, []);

    const GET_ALL_USER_DATA = async () => {
        const response = await GET_ALL_USER();
        response && setUserData(response?.users);
    };

    const handleSelect = (key) => {
        setActiveTab(key);
        setSelectGmailUser('');
    };

    const GET_ALL_Whastpp_DATA = async () => {
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        }
    };

    const checkDuplicate = (boardId, gmailUserId) => {
        if (!Array.isArray(automationsData) || !boardId) return false;

        if (selectedType === 'new') {
            if (!gmailUserId) return false;

            return automationsData.some((auto) => {
                if (editId && auto.id === editId) return false;
                const sameType = auto?.type === selectedType;
                const hasBoardInAction = auto?.action?.some((action) => action.boardId === boardId);
                const whenMatchesGmail = auto?.when?.gmailUserId === gmailUserId;
                return sameType && whenMatchesGmail && hasBoardInAction;
            });
        }


        return automationsData.some((auto) => {
            if (auto?.type !== selectedType || (editId && auto.id === editId)) {
                return false;
            }


            const boardInConditions = auto?.condition?.some(
                (cond) => cond.operand === 'board' && cond.value === boardId,
            );


            const boardInActions = auto?.action?.some((action) => action.boardId === boardId);


            const boardInWhen = auto?.when?.boardId === boardId;

            return boardInConditions || boardInActions || boardInWhen;
        });
    };



    const handleBoardChange = (value) => {
        setBoardSelect(value);
        setIsDuplicate(false);
        setDuplicateMsg('');
    };


    const boardUserData = boardSelect ? boardUsers : userData;
    const mapUsersToOptions = (users) =>
        (users || []).map((user) => ({ value: user.id, label: user.name, email: user.email }));

    const getUsersForBoardId = (boardId) => {
        if (!boardId) return boardUserData || [];
        if (boardId === boardSelect) return boardUsers || [];
        return boardUsersByBoard[boardId] || [];
    };

    const getOptionsForRow = (row) => {
        const boardId = row?.boardId || boardSelect;
        return mapUsersToOptions(getUsersForBoardId(boardId));
    };

    const isBoardUsersLoadingForRow = (row) => {
        const boardId = row?.boardId || boardSelect;
        return boardUsersLoading && boardUsersLoadingBoardId === boardId;
    };

    const options = mapUsersToOptions(boardUserData);
    const availableActions = [
        { label: 'assign it to', value: 'assignTo' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];

    const addActionRow = () => {
        setActionRows([...actionRows, { action: '', user: '', boardId: '', entityId: '' }]);
    };

    const updateAction = (index, value) => {
        const updated = [...actionRows];

        if (selectedType === 'new' && index === 0) {
            const selectedBoard = boardName.find((b) => b.value === value);

            updated[index].action = 'createOnList';
            updated[index].boardId = value;
            updated[index].entityId = '';
            updated[index].user = '';

            setShowAction(value);
        } else {
            if (boardName.some((b) => b.value === value)) {
                updated[index].boardId = value;
                // Preload users for this board into cache
                GET_BOARD_USER_DATA(value);
            } else {
                updated[index].action = value;
                updated[index].user = '';
                updated[index].boardId = '';
                updated[index].entityId = '';
                updated[index].templateId = '';
                updated[index].language = '';
                updated[index].subject = '';
                updated[index].body = '';


                if (value === 'sendOverdueAlert') {
                    updated[index].message = '🔥Overdue - Customer is waiting for a reply.';
                } else if (value === 'sendUpcomingAlert') {
                    updated[index].message = "⚡Upcoming soon - Don't forget";
                } else if (value === 'sendNotificationTo') {
                    updated[index].message = 'Issue escalated to you';
                } else if (value === 'sendFollowUpToCustomer') {
                    updated[index].message = 'Create Follow-up Reminder';
                }
            }
        }

        setActionRows(updated);
    };
    const updateUser = (index, value, isMulti = false) => {
        setActionRows(prev => {
            const updated = [...prev];

            // Ensure no holes in the array
            for (let i = 0; i <= index; i++) {
                if (!updated[i]) {
                    updated[i] = { ...initialActionRow };
                }
            }

            const action = updated[index].action;

            if (action === "assignTo") {
                updated[index].user = value;
            }
            else if (action === "assignToRoundRobin") {
                updated[index].users = value;
            }
            else if (action === "setEmailLabel") {
                updated[index].user = value;
            }
            else if (action === "setCustomProperty") {
                // keep every alias in sync — edit mode loads the saved id into user/customProperty,
                // and validation/payload read user first, so a stale copy would override the new pick
                updated[index] = { ...updated[index], propertyId: value, user: value, customProperty: value };
            }

            return updated;
        });
    };


    const showUserSelectFor = ['assignTo', 'assignToRoundRobin', 'setEmailLabel', 'setCustomProperty'];
    const isCustomPropertyUsed = actionRows?.some(
        (row) => showUserSelectFor.includes(row.action) && row.action === 'setCustomProperty'
    );
    useEffect(() => {
        if (isCustomPropertyUsed && !boardSelect) {
            setBoardError('Please select board for custom property');
        } else {
            setBoardError('');
        }
    }, [isCustomPropertyUsed, boardSelect]);
    const shouldHideAddButton =
        ['markComplete', 'markIncomplete'].includes(actionRows[1]?.action) || actionRows.length >= 3;

    const customPropertyThenOption = [
        { label: 'Text (Multiple lines)', value: 'text' },
        { label: 'Team member', value: 'team_member' },
        { label: 'Contact/Company', value: 'contact_company' },
        { label: 'Task', value: 'task' },
        { label: 'Status', value: 'status' },
        { label: 'Tag', value: 'tag' },
        { label: 'Multi-select', value: 'multi_select' },
        { label: 'File', value: 'file' },
        { label: 'URL', value: 'url' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Number', value: 'number' },
        { label: 'Text (Single line)', value: 'text' },
    ];



    const updateConditionField = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, field: value, value: '' };

                    if (value === 'assignee') {
                        newCond.operator = 'equals';
                    } else if (value === 'customerWaiting' || value === 'customerNotResponding') {
                        newCond.operator = 'moreThanMins';
                    }
                    return newCond;
                }
                return cond;
            }),
        );
    };

    const updateConditionOperator = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => (i === index ? { ...cond, operator: value, value: '' } : cond)),
        );
    };

    const updateConditionValue = (index, value) => {
        setConditions((prev) => {
            const updated = prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, value };
                    return newCond;
                }
                return cond;
            });
            return updated;
        });
    };

    // Languages of a template that actually have a body
    const getTemplateLanguageOptions = (templateId) => {
        const tpl = templateOptions.find((t) => t.value === templateId);
        if (!tpl) return [];
        return [
            AUTO_LANGUAGE_OPTION,
            ...Object.entries(tpl.languages)
                .filter(([, v]) => (v.body || '').trim())
                .map(([lang]) => ({ value: lang, label: lang })),
        ];
    };

    // Subject/body shown for a template + language. Auto shows the English text (what is sent when the
    // customer's language is unknown); the server picks the customer's language when sending.
    const templateContent = (tpl, language) => {
        const available = Object.entries(tpl.languages)
            .filter(([, v]) => (v.body || '').trim())
            .map(([l]) => l);
        const auto = !language || language === AUTO_LANGUAGE;
        const shown = auto
            ? (available.includes('English') ? 'English' : available[0] || 'English')
            : (available.includes(language) ? language : available[0] || 'English');
        const content = tpl.languages[shown] || { subject: '', body: '' };
        return { language: auto ? AUTO_LANGUAGE : shown, subject: content.subject, body: content.body };
    };

    // Picking a template (or a language) auto-fills the subject and body; both stay editable
    const applyTemplateToRow = (index, templateId, language) => {
        const tpl = templateOptions.find((t) => t.value === templateId);
        setActionRows((prev) =>
            prev.map((r, i) => {
                if (i !== index) return r;
                if (!tpl) return { ...r, templateId, language: '', subject: '', body: '' };
                return { ...r, templateId, ...templateContent(tpl, language) };
            }),
        );
    };

    const updateTemplateId = (index, value) => applyTemplateToRow(index, value, actionRows[index]?.language);

    // Extra follow-ups of a "Send an email to the customer" row (no reply from customer)
    const updateFollowUps = (index, change) =>
        setActionRows((prev) => prev.map((r, i) => (i === index ? { ...r, followUps: change(r.followUps || []) } : r)));
    const addFollowUp = (index) =>
        updateFollowUps(index, (list) => [
            ...list,
            { after: { value: '', unit: 'days' }, templateId: '', language: '', subject: '', body: '' },
        ]);
    const removeFollowUp = (index, fi) => updateFollowUps(index, (list) => list.filter((_, j) => j !== fi));
    const updateFollowUp = (index, fi, patch) =>
        updateFollowUps(index, (list) => list.map((f, j) => (j === fi ? { ...f, ...patch } : f)));
    const applyTemplateToFollowUp = (index, fi, templateId, language) => {
        const tpl = templateOptions.find((t) => t.value === templateId);
        if (!tpl) return updateFollowUp(index, fi, { templateId, language: '', subject: '', body: '' });
        updateFollowUp(index, fi, { templateId, ...templateContent(tpl, language) });
    };

    const updateEmailField = (index, key, value) => {
        setActionRows((prev) => prev.map((r, i) => (i === index ? { ...r, [key]: value } : r)));
    };

    const updateMessage = (index, value) => {
        const updated = [...actionRows];
        updated[index].message = value;
        setActionRows(updated);
    };

    const buildPayload = () => {
        const staticCondition = {
            field: 'board',
            operator: 'equals',
            value: boardSelect,
        };
        if (runOnExistingEmails) {
            const existing = conditions.find(
                (c) => c.field === "existingInboxMails"
            );

            if (existing) {
                existing.value = days;
            } else {
                conditions.push({
                    field: "existingInboxMails",
                    operator: "lte",
                    value: days,
                });
            }

        } else {
            const index = conditions.findIndex(
                (c) => c.field === "existingInboxMails"
            );

            if (index !== -1) {
                conditions.splice(index, 1);
            }
        }



        let allConditions = conditions;
        if (
            selectedType === 'itemAdded' ||
            selectedType === 'noReplyToCustomer' ||
            selectedType === 'noReplyFromCustomer'
        ) {

            const hasBoardCondition = conditions.some((cond) => cond.field === 'board');
            if (!hasBoardCondition) {
                allConditions = [staticCondition, ...conditions];
            }
        }

        return {

            type: selectedType,
            when: {
                gmailUserId: selectedMailUser ? selectedMailUser?.value : '',
            },
            checklist: showChecklist
                ? (checklistByRow['default'] || []).filter((item) => item.text.trim()).map((item) => toChecklistPayload(item, checklistOrder))
                : [],
            checklistMandatory: showChecklist && checklistMandatory,
            condition: allConditions.map((c) => ({
                operand: c.field,
                operator: c.operator,
                value: c.field === 'assignee' ? [{ entityId: c.value }] : c.value,
            })),
            action: (() => {
                const baseActions = actionRows.map((a, index) => {
                    let actionName = a.action;


                    if (a.action === 'moveToNext') {
                        actionName = 'moveToNextList';
                    } else if (a.action === 'moveToPreviousList') {
                        actionName = 'moveToPreviousList';
                    }

                    const payload = {
                        action: actionName,
                        order: index,
                        // which move direction(s) this action runs for (both = same as before)
                        ...(selectedType === 'itemAdded' ? { directions: normalizeDirections(a.directions) } : {}),
                    };

                    if (a.action === 'createOnList') {
                        return {
                            ...payload,
                            boardId: a.boardId,
                            entityId: a.entityId,
                        };
                    }

                    if (['assignTo', 'unassign'].includes(a.action)) {
                        return {
                            ...payload,
                            entityId: a.user,
                        };
                    }

                    if (a.action === 'assignToRoundRobin') {
                        return {
                            ...payload,
                            entityIds:
                                a.users?.map((u) => ({
                                    entityId: u.value,
                                    name: u.label,
                                })) || [],
                        };
                    }


                    if (a.action === 'setEmailLabel') {
                        return {
                            ...payload,
                            action: 'setEmailLabel',
                            labelName: a.user ? a.user.name || a.user.label : '',
                            ...(a.user?.parentId ? { parentId: a.user.parentId } : {}),
                        };
                    }

                    if (a.action === 'setCustomProperty') {
                        const customPropertyId = a.user || a.customPropertyId || a.propertyId || '';

                        // Always take the correct array from selectedCustomFieldByRow
                        let customFieldArray = [];

                        if (selectedCustomFieldByRow?.[index]) {
                            // Already correct format: [{id:"..."}, {id:"..."}]
                            customFieldArray = selectedCustomFieldByRow[index];
                        }

                        // Fallback for edit mode (single ID)
                        else if (a.customFieldId || a.entityId || a.selectedCustomFieldId) {
                            customFieldArray = [
                                { id: String(a.customFieldId || a.entityId || a.selectedCustomFieldId) }
                            ];
                        }

                        return {
                            ...payload,
                            action: "setCustomProperty",
                            customProperty: customPropertyId,
                            customField: customFieldArray,
                            ...(selectedType === 'itemAdded' ? { onConflict: a.onConflict || 'keep', reverse: !!a.reverse } : {}),
                            checklist: (checklistByRow[index] || []).filter((item) => item.text.trim()).map((item) => toChecklistPayload(item)),
                        };
                    }




                    if (a.action === 'setSlaAlertTag') {
                        return {
                            ...payload,
                            entityValue: a.entityId || [],
                        };
                    }

                    if (a.action === 'sendEmailToCustomer') {
                        return {
                            ...payload,
                            templateId: a.templateId || '',
                            language: a.language || '',
                            subject: a.subject || '',
                            body: a.body || '',
                            // 2nd / 3rd / final follow-up, each `after` the previous email while the customer stays silent
                            ...(selectedType === 'noReplyFromCustomer'
                                ? {
                                    followUps: (a.followUps || []).map((f) => ({
                                        after: { value: Number(f.after?.value), unit: f.after?.unit || 'days' },
                                        templateId: f.templateId || '',
                                        language: f.language || '',
                                        subject: f.subject || '',
                                        body: f.body || '',
                                    })),
                                }
                                : {}),
                        };
                    }

                    if (a.action === 'sendFollowUpToCustomer') {
                        return {
                            ...payload,
                            templateHtml: a.message || '',
                        };
                    }

                    if (
                        a.action === 'sendOverdueAlert' ||
                        a.action === 'sendUpcomingAlert' ||
                        a.action === 'sendNotificationTo'
                    ) {
                        return {
                            ...payload,
                            entityId: a.entityId,
                            entityValue: a.message || '',
                        };
                    }

                    return payload;
                });

                if (selectedType === 'new') {
                    baseActions.push({ action: 'subEmailInbox', isProcessed: skipReplies });
                    baseActions.push({ action: 'emailInbox', hasReply: skipInbox });
                }
                return baseActions;
            })(),
        };
    };

    const updateBoardList = (index, value) => {
        const updated = [...actionRows];
        updated[index].entityId = value;
        setActionRows(updated);
    };

    const handleMailUserChange = (selectedOption) => {
        setSelectedMailUser(selectedOption);
        setIsDuplicate(false);
        setDuplicateMsg('');
    };

    useEffect(() => {
        if (!editId) {
            setSelectedType('new');
        }
    }, []);


    useEffect(() => {
        const gmailUserId = selectedMailUser?.value ?? null;

        if (!selectedType || !boardSelect) {
            setIsDuplicate(false);
            setDuplicateMsg('');
            return;
        }

        if (selectedType === 'new' && !gmailUserId) {
            setIsDuplicate(false);
            setDuplicateMsg('');
            return;
        }
        const duplicate = checkDuplicate(boardSelect, gmailUserId);
        setIsDuplicate(duplicate);
        if (duplicate) {
            if (selectedType === 'new') {
                setDuplicateMsg('Automation already exists for this gmail user and board.');
            } else {
                setDuplicateMsg(`Automation of type "${selectedType}" already exists for this board.`);
            }
        } else {
            setDuplicateMsg('');
        }
    }, [selectedType, boardSelect, selectedMailUser, automationsData, editId]);

    const handleGetSyncGmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            const formattedOptions = response?.data?.map((item) => ({
                value: item.id,
                label: item.email,
            }));

            setSyncGmail(formattedOptions);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        handleGetSyncGmail();
    }, []);

    const no_reply_to_customer = [
        { label: 'more than (hours)', value: 'moreThanHrs' },
        { label: 'more than (minutes)', value: 'moreThanMins' },
        { label: 'more than (days)', value: 'moreThanDays' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];

    const no_reply_then_condition = [
        { label: 'Set an SLA alert on the card', value: 'setSlaAlertTag' },
        { label: 'Send an overdue alert to', value: 'sendOverdueAlert' },
        { label: 'Send an upcoming alert to', value: 'sendUpcomingAlert' },
        { label: 'Send a notification to', value: 'sendNotificationTo' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' },
        { label: 'Create Follow-up Reminder', value: 'sendFollowUpToCustomer' },
        { label: 'Send an email to the customer', value: 'sendEmailToCustomer' },
    ];

    const selectedIsFields = Array.isArray(conditions)
        ? conditions
            .filter((c, i) => c.operator === 'equals')
            .map((c) => c.field)
            .filter(Boolean)
        : [];

    const selectedActionTypes = actionRows.map((row) => row?.action).filter(Boolean);

    const selectedFirstAction = Array.isArray(actionRows) && actionRows[0]?.action ? actionRows[0].action : null;
    const lastTwoSelected = selectedActionTypes.slice(-2);
    const [searchTerm, setSearchTerm] = useState('');

    function flattenLabels(labels, parentPath = [], parentId = null) {
        let options = [];
        labels.forEach(label => {
            const currentPath = [...parentPath, label.name];
            options.push({
                label: currentPath.join('/'),
                value: JSON.stringify({
                    parentId: parentId,
                    childId: label.id,
                    name: label.name,
                }),
            });
            if (label.children && label.children.length) {
                options = options.concat(flattenLabels(label.children, currentPath, label.id));
            }
        });
        return options;
    }

    const allOptions = useMemo(() => flattenLabels(lables), [lables]);

    const filteredOptions = useMemo(() => {
        if (!searchTerm) return allOptions;
        return allOptions.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [allOptions, searchTerm]);

    const deleteCustomField = async (id, idx, status) => {
        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);
            const propertyId = actionRows[idx]?.propertyId || actionRows[idx]?.customProperty;
            if (propertyId) {
                await handlePropertySelect(idx, propertyId);
            }
        } catch (error) {
            console.error('Failed to delete custom field or refresh properties', error);
        }
    };

    const handlePropertySelect = async (rowIndex, propertyId) => {
        updateUser(rowIndex, propertyId);

        if (!propertyId) {
            setCustomFieldOptionsByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setSelectedCustomFieldByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setCustomFieldErrorByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            return;
        }

        setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: true }));
        setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: null }));

        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(propertyId);

            const options = (response?.data?.data || []).map(item => {
                const cf = item?.customField ?? {};
                const valueField = cf?.value;

                const getLabel = (v) =>
                    typeof v === "object" && v !== null
                        ? v.label ?? v.name ?? v.value ?? ""
                        : (v ?? "");

                const label = Array.isArray(valueField)
                    ? valueField.map(getLabel).join(", ")
                    : getLabel(valueField);

                return {
                    label: label || cf.name || "Unnamed",
                    value: cf.id ?? item?.id ?? "",
                    _rawCustomField: cf,
                    _rawItem: item
                };
            });

            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: options }));

            // ❌ previously ""
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [rowIndex]: prev[rowIndex] ?? []
            }));


        } catch (err) {
            console.error('Failed to fetch custom fields for property', err);
            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: [] }));
            setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: 'Failed to load fields' }));
        } finally {
            setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: false }));
        }
    };


    const getChecklistRows = (rowIndex) => {
        const rows = checklistByRow[rowIndex];
        return rows && rows.length > 0 ? rows : [{ id: `${rowIndex}-0`, text: '' }];
    };

    const addChecklistItem = (rowIndex) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            return {
                ...prev,
                [rowIndex]: [...rows, { id: `${rowIndex}-${Date.now()}`, text: '' }],
            };
        });
    };

    const updateChecklistItem = (rowIndex, itemId, value) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            return {
                ...prev,
                [rowIndex]: rows.map((item) => (item.id === itemId ? { ...item, text: value } : item)),
            };
        });
    };

    const removeChecklistItem = (rowIndex, itemId) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            const updated = rows.filter((item) => item.id !== itemId);
            return {
                ...prev,
                [rowIndex]: updated.length > 0 ? updated : [{ id: `${rowIndex}-0`, text: '' }],
            };
        });
    };

    const setChecklistItemAction = (rowIndex, itemId, onCheck) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            return {
                ...prev,
                [rowIndex]: rows.map((item) => (item.id === itemId ? { ...item, onCheck } : item)),
            };
        });
    };

    const toggleChecklistChecksBelow = (rowIndex, itemId) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            return {
                ...prev,
                [rowIndex]: rows.map((item) => (item.id === itemId ? { ...item, checksBelow: !item.checksBelow } : item)),
            };
        });
    };

    // lock (must be checked in order) <-> chain (optional) of one task, used when the order rule is mandatory
    const toggleChecklistItemOptional = (rowIndex, itemId) => {
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [{ id: `${rowIndex}-0`, text: '' }];
            return {
                ...prev,
                [rowIndex]: rows.map((item) => (item.id === itemId ? { ...item, optional: !item.optional } : item)),
            };
        });
    };

    const [dragChecklist, setDragChecklist] = useState(null); // { rowIndex, id }
    const [dragOverChecklistId, setDragOverChecklistId] = useState(null);

    const moveChecklistItem = (rowIndex, fromId, toId) => {
        if (fromId === toId) return;
        setChecklistByRow((prev) => {
            const rows = prev[rowIndex] && prev[rowIndex].length > 0 ? prev[rowIndex] : [];
            const from = rows.findIndex((r) => r.id === fromId);
            const to = rows.findIndex((r) => r.id === toId);
            if (from < 0 || to < 0) return prev;
            const next = [...rows];
            const [moved] = next.splice(from, 1);
            next.splice(to, 0, moved);
            return { ...prev, [rowIndex]: next };
        });
    };

    const renderChecklistRows = (rowIndex) => (
        <>
            {getChecklistRows(rowIndex).map((item, itemIdx, rows) => (
                <div
                    key={item.id}
                    className="flex items-center gap-2 mb-2"
                    onDragOver={(e) => {
                        if (dragChecklist && dragChecklist.rowIndex === rowIndex) {
                            e.preventDefault();
                            setDragOverChecklistId(item.id);
                        }
                    }}
                    onDrop={(e) => {
                        e.preventDefault();
                        if (dragChecklist && dragChecklist.rowIndex === rowIndex) {
                            moveChecklistItem(rowIndex, dragChecklist.id, item.id);
                        }
                        setDragChecklist(null);
                        setDragOverChecklistId(null);
                    }}
                    style={{
                        flexWrap: 'wrap',
                        opacity: dragChecklist?.id === item.id ? 0.4 : 1,
                        borderTop: dragOverChecklistId === item.id && dragChecklist?.id !== item.id ? '2px solid #1a7d3e' : '2px solid transparent',
                    }}
                >
                    {rows.length > 1 && (
                        <span
                            draggable
                            title="Drag to reorder"
                            onDragStart={(e) => {
                                e.dataTransfer.effectAllowed = 'move';
                                e.dataTransfer.setData('text/plain', item.id);
                                if (e.currentTarget.parentElement) e.dataTransfer.setDragImage(e.currentTarget.parentElement, 10, 10);
                                setDragChecklist({ rowIndex, id: item.id });
                            }}
                            onDragEnd={() => {
                                setDragChecklist(null);
                                setDragOverChecklistId(null);
                            }}
                            style={{ cursor: 'grab', color: '#9ca3af', display: 'flex', flexShrink: 0 }}
                        >
                            <FiMenu size={15} />
                        </span>
                    )}
                    {rowIndex === 'default' ? (
                        <OrderBadge
                            index={itemIdx}
                            mode={checklistOrder}
                            optional={item.optional}
                            onToggle={() => toggleChecklistItemOptional(rowIndex, item.id)}
                        />
                    ) : (
                        itemIdx !== rows.length - 1 && <FiCheck size={15} color="#1a7d3e" style={{ flexShrink: 0 }} />
                    )}
                    <input
                        type="text"
                        className="border border-gray-300 rounded px-3 py-2 bg-white text-sm"
                        style={{ flex: 1, minWidth: '200px' }}
                        placeholder="Type task description here"
                        value={item.text}
                        onChange={(e) => updateChecklistItem(rowIndex, item.id, e.target.value)}
                    />
                    {itemIdx < rows.length - 1 && (
                        <label
                            className="flex items-center gap-1 text-xs"
                            title="When this task is checked on the ticket, every task below it is checked too"
                            style={{ whiteSpace: 'nowrap', cursor: 'pointer', color: item.checksBelow ? '#1a7d3e' : '#6b7280', flexShrink: 0 }}
                        >
                            <input
                                type="checkbox"
                                checked={!!item.checksBelow}
                                onChange={() => toggleChecklistChecksBelow(rowIndex, item.id)}
                            />
                            Checks all below
                        </label>
                    )}
                    {/* only the automation's own checklist reaches the ticket */}
                    {rowIndex === 'default' && (
                        <ChecklistItemAction
                            value={item.onCheck}
                            onChange={(onCheck) => setChecklistItemAction(rowIndex, item.id, onCheck)}
                            boardOptions={boardName}
                            ruleBoardId={boardSelect}
                            ruleListId={ruleListId}
                        />
                    )}
                    {getChecklistRows(rowIndex).length > 1 && (
                        <button
                            type="button"
                            className="text-red-500 font-bold px-2"
                            onClick={() => removeChecklistItem(rowIndex, item.id)}
                        >
                            ×
                        </button>
                    )}
                    {itemIdx === getChecklistRows(rowIndex).length - 1 && (
                        <button type="button" className="automation-add-btn" onClick={() => addChecklistItem(rowIndex)}>
                            <FiPlus size={13} />
                            Add task
                        </button>
                    )}
                </div>
            ))}
        </>
    );

    const renderChecklistBuilder = (rowIndex) => (
        <div className="w-full mt-2" style={{ flexBasis: '100%', order: 99 }}>
            {rowIndex === 'default' && (
                <OrderRuleRadio value={checklistOrder} onChange={setChecklistOrder} name="automation-checklist-order" />
            )}
            {renderChecklistRows(rowIndex)}
        </div>
    );

    const isChecklistRowEnabledDefault = (rowIndex) =>
        getChecklistRows(rowIndex).some((item) => item.text && item.text.trim());

    const updateOnConflict = (rowIndex, value) => {
        setActionRows((prev) => prev.map((r, i) => (i === rowIndex ? { ...r, onConflict: value } : r)));
    };

    const updateReverse = (rowIndex, checked) => {
        setActionRows((prev) => prev.map((r, i) => (i === rowIndex ? { ...r, reverse: checked } : r)));
    };

    // Only the "item added / moved to a list" automation applies this choice
    const renderConflictOption = (rowIndex) => {
        if (selectedType !== 'itemAdded') return null;
        const value = actionRows[rowIndex]?.onConflict || 'keep';
        // "when the ticket leaves the list" needs a list: the automation must have a "the list name is ..." condition
        const hasListCondition =
            Array.isArray(conditions) &&
            conditions.some((c) => ['listName', 'list'].includes(c.field) && c.operator === 'equals' && c.value);
        const reverseChecked = !!actionRows[rowIndex]?.reverse && hasListCondition;
        return (
            <div className="w-full mt-2 flex flex-wrap items-center gap-2 text-xs font-medium text-gray-600" style={{ flexBasis: '100%', order: 98 }}>
                <span>If the ticket already has a status of this property:</span>
                <AppSelect portal
                    value={value}
                    onChange={(e) => updateOnConflict(rowIndex, e.target.value)}
                    style={{ height: '34px', fontSize: '13px', color: '#374151' }}
                    minWidth="300px"
                    options={[
                        { value: 'keep', label: 'Keep both' },
                        { value: 'replace', label: 'Remove the other and add only the new one' },
                    ]}
                />
                <label
                    className="flex items-center gap-2"
                    style={{ flexBasis: '100%', cursor: hasListCondition ? 'pointer' : 'not-allowed', opacity: hasListCondition ? 1 : 0.6 }}
                >
                    <input
                        type="checkbox"
                        checked={reverseChecked}
                        disabled={!hasListCondition}
                        onChange={(e) => updateReverse(rowIndex, e.target.checked)}
                        style={{ accentColor: '#1a7d3e', width: '14px', height: '14px' }}
                    />
                    Also apply in reverse: when the ticket leaves this list, remove the status it added and restore the previous status
                    {!hasListCondition && ' (add the condition "the list name is ..." first)'}
                </label>
            </div>
        );
    };

    const toggleDirection = (rowIndex, direction, checked) => {
        setActionRows((prev) => prev.map((r, i) => {
            if (i !== rowIndex) return r;
            const current = Array.isArray(r.directions) ? r.directions : MOVE_DIRECTIONS;
            const next = checked ? [...new Set([...current, direction])] : current.filter((d) => d !== direction);
            // keep "directions" as typed so both boxes can be unticked (blocked on save with a message)
            return { ...r, directions: next };
        }));
    };

    // Only the "item added / moved to a list" automation: run this action when the ticket comes from the left and/or right
    const renderDirectionOption = (rowIndex) => {
        if (selectedType !== 'itemAdded') return null;
        const row = actionRows[rowIndex] || {};
        if (!row.action) return null;
        const directions = Array.isArray(row.directions) ? row.directions : MOVE_DIRECTIONS;
        const options = [
            { value: 'right', label: 'Moved forward → (coming from a list on the left, or created in this list)' },
            { value: 'left', label: 'Moved back ← (coming from a list on the right)' },
        ];
        return (
            <div className="w-full mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-medium text-gray-600" style={{ flexBasis: '100%', order: 97 }}>
                <span style={{ flexBasis: '100%' }}>Apply this action when the ticket is:</span>
                {options.map((opt) => (
                    <label key={opt.value} className="flex items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={directions.includes(opt.value)}
                            onChange={(e) => toggleDirection(rowIndex, opt.value, e.target.checked)}
                            style={{ accentColor: '#1a7d3e', width: '14px', height: '14px' }}
                        />
                        {opt.label}
                    </label>
                ))}
            </div>
        );
    };

    // Temporarily hidden: "Create a task for this action (optional)" option
    const renderActionChecklistSection = (rowIndex) => {
        return null;
        // const enabled = checklistEnabledByRow[rowIndex] ?? isChecklistRowEnabledDefault(rowIndex);
        // return (
        //     <div className="w-full mt-2" style={{ flexBasis: '100%', order: 99 }}>
        //         <label className="flex items-center gap-2 text-xs font-medium text-gray-600" style={{ cursor: 'pointer' }}>
        //             <input
        //                 type="checkbox"
        //                 checked={enabled}
        //                 onChange={(e) => {
        //                     const checked = e.target.checked;
        //                     setChecklistEnabledByRow((prev) => ({ ...prev, [rowIndex]: checked }));
        //                     if (!checked) {
        //                         setChecklistByRow((prev) => ({ ...prev, [rowIndex]: [] }));
        //                     }
        //                 }}
        //                 style={{ accentColor: '#1a7d3e', width: '14px', height: '14px' }}
        //             />
        //             Create a task for this action (optional)
        //         </label>
        //         {enabled && <div className="mt-2">{renderChecklistRows(rowIndex)}</div>}
        //     </div>
        // );
    };

    const defaultColorMap = {
        Done: '#4ade80',
        'Working on': '#facc15',
        Stuck: '#f87171',
        'Waiting for approval': '#60a5fa',
        default: '#9ca3af',
    };
    const [customeFiedId, setCustomeFieldId] = useState(null);
    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };


    const handleUpdateCell = async (propertyId, newValue, color, idx, flag) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            const payload = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };

            const createTag = await services.customfield.CREATE_CUSTOM_FIELD(payload);

            const newField = createTag?.data?.data;
            if (!newField) return;

            const newOption = {
                id: newField.id,
                value: newField.id,
                label: newValue,
                color: color,
                _rawItem: {
                    id: newField.id,
                    customField: {
                        value: newValue,
                        color: color,
                    },
                },
            };

            // ✅ Update dropdown options
            setCustomFieldOptionsByRow(prev => ({
                ...prev,
                [idx]: [...(prev[idx] || []), newOption],
            }));

            // ✅ Update selected values
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [idx]: [
                    ...(prev[idx] || []),
                    {
                        id: newField.id,
                        label: newValue,
                        color: color,
                    },
                ],
            }));

            // fetchProperty(propertyId);
        } catch (error) {
            console.error('Failed to create custom field', error);
        }
    };


    const handleUpdatedCustomField = async (propertyId, newValue, color, field, idx) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            // 👇 Convert to correct array structure
            const customFieldArray = selectedCustomFieldByRow[idx] || [];
            const data = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };


            const responsedata = await services.customfield.UPDATE_CUSTOM_FIELD(customeFiedId, data);

            if (responsedata?.status === 200) {
                setSelectedCustomFieldByRow(prev => ({
                    ...prev,
                    [idx]: data
                }));
                await handlePropertySelect(idx, propertyId);
            }

            setCustomeFieldId(null);
        } catch (error) {
            console.error('Failed to update custom field', error);
        }
    };


    const footerButtons = (
        <div style={{ display: 'flex', gap: '10px' }}>
            <button
                style={{
                    padding: '8px 20px', fontSize: '13px', fontWeight: '600',
                    color: '#374151', backgroundColor: '#f3f4f6',
                    border: '1.5px solid #e5e7eb', borderRadius: '8px',
                    cursor: 'pointer', transition: 'background-color 0.15s ease',
                }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e5e7eb'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                onClick={() => setStep(1)}
            >
                Cancel
            </button>
            <button
                style={{
                    padding: '8px 22px', fontSize: '13px', fontWeight: '600',
                    color: '#fff', backgroundColor: '#1a7d3e', border: 'none',
                    borderRadius: '8px', cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(26,125,62,0.3)',
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    transition: 'background-color 0.15s ease',
                }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                onClick={() => {
                    if (!boardSelect) {
                        toast.error('Please Select Board');
                        return;
                    } else if (selectedType === 'new' && !selectedMailUser) {
                        toast.error('Please Select Gmail User');
                        return;
                    } else {
                        const hasInvalidMinutes = conditions.some((cond) => {
                            if (cond.operator === 'moreThanMins' && cond.field === 'customerWaiting') {
                                const minutes = parseInt(cond.value);
                                return isNaN(minutes) || minutes < 2;
                            }
                            if (cond.operator === 'moreThanMins' && cond.field === 'teamWaiting') {
                                const minutes = parseInt(cond.value);
                                return isNaN(minutes) || minutes < 2;
                            }
                            return false;
                        });
                        if (hasInvalidMinutes) return;
                        handleCreate();
                    }
                }}
            >
                <FiSave size={13} />
                {editId ? 'Update' : 'Create'}
            </button>
        </div>
    );

    // Board ticket process (order of lists), ticket priority (order inside lists) and property status -> trip status / list link have their own forms
    const SeparateForm =
        selectedType === PROPERTY_STATUS_LINK_TYPE
            ? PropertyStatusLinkForm
            : selectedType === LIST_PROCESS_TYPE
                ? ListProcessForm
                : selectedType === TICKET_PRIORITY_TYPE
                    ? TicketPriorityForm
                    : null;
    if (SeparateForm) {
        return (
            <SeparateForm
                show={show}
                onHide={onHide}
                onCancel={() => setStep(1)}
                editId={editId}
                boardName={boardName}
                onTypeChange={(type) => {
                    setSelectedType(type);
                    setActionRows([{ action: '', order: '', boardId: '', entityId: '' }]);
                    setConditions(
                        type === 'itemAdded'
                            ? defaultMailConditions
                            : type === 'noReplyToCustomer'
                                ? defaultNoReplyToCustomerConditions
                                : type === 'noReplyFromCustomer'
                                    ? defaultNoReplyFromCustomerConditions
                                    : [{ field: conditionOptions[0].value, operator: operatorOptions[2].value, value: '' }],
                    );
                }}
                onSaved={() => {
                    setStep(1);
                    getAllAutomation && getAllAutomation();
                }}
            />
        );
    }

    return (
        <AppModal
            show={show}
            onClose={onHide}
            icon={<FiZap size={17} color="#fff" />}
            title={editId ? 'Edit Automation' : 'Create a new automation'}
            subtitle="Set up triggers, conditions and actions"
            maxWidth="960px"
            footer={footerButtons}
        >
            <div className="automation-form">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

                    <div className="flex items-center gap-3">
                        <span className="font-medium text-gray-700 w-[60px]">When</span>
                        <AppSelect portal
                            value={selectedType}
                            style={{ height: '38px', fontSize: '13px', color: '#1f2937', minWidth: '220px' }}
                            onChange={(e) => {
                                const type = e.target.value;
                                setSelectedType(type);
                                setActionRows([{ action: '', order: '', boardId: '', entityId: '' }]);
                                setIsDuplicate(false);
                                setDuplicateMsg('');
                                setConditions([]);
                                setSelectedMailUser(null);
                                setChecklistByRow({});
                                setShowChecklist(false);
                                setChecklistMandatory(false);
                                setChecklistOrder(ORDER_OPTIONAL);
                                setSelectedCustomFieldByRow({});
                                setCustomFieldOptionsByRow({});
                                if (type === 'itemAdded') {
                                    setConditions(defaultMailConditions);
                                } else if (type === 'noReplyToCustomer') {
                                    setConditions(defaultNoReplyToCustomerConditions);
                                } else if (type === 'noReplyFromCustomer') {
                                    setConditions(defaultNoReplyFromCustomerConditions);
                                } else {
                                    setConditions([
                                        {
                                            field: conditionOptions[0].value,
                                            operator: operatorOptions[2].value,
                                            value: '',
                                        },
                                    ]);
                                }
                            }}
                            options={[
                                { value: 'new', label: 'a new mail is received' },
                                { value: 'itemAdded', label: 'an item is added / moved to a list' },
                                { value: 'noReplyToCustomer', label: 'there is no reply to a customer' },
                                { value: 'noReplyFromCustomer', label: 'there is no reply from a customer' },
                                { value: PROPERTY_STATUS_LINK_TYPE, label: 'a property status is set on a ticket' },
                                { value: LIST_PROCESS_TYPE, label: 'tickets must follow the lists in order (ticket process)' },
                                { value: TICKET_PRIORITY_TYPE, label: 'tickets are ordered by status priority (ticket priority)' },
                            ]}
                        />
                        {selectedType == 'new' && (
                            <>
                                <input
                                    type="text"
                                    className="border border-gray-300 rounded px-3 bg-white"
                                    style={{ height: '38px', fontSize: '13px', color: '#1f2937', width: '120px', flexShrink: 0 }}
                                    value="in the mailbox"
                                    readOnly
                                />
                                <Select
                                    options={syncGmail}
                                    value={selectedMailUser}
                                    onChange={handleMailUserChange}
                                    placeholder="Select..."
                                    styles={{
                                        container: (base) => ({ ...base, width: '250px', fontSize: '13px' }),
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '38px',
                                            height: '38px',
                                            borderRadius: '6px',
                                            border: '1px solid #d1d5db',
                                            boxShadow: 'none',
                                            outline: 'none',
                                            backgroundColor: '#fff',
                                            '&:hover': { borderColor: '#d1d5db' },
                                            '&:focus-within': { border: '1px solid #d1d5db', boxShadow: 'none' },
                                        }),
                                        valueContainer: (base) => ({ ...base, padding: '0 10px', height: '36px' }),
                                        input: (base) => ({ ...base, margin: 0, padding: 0, caretColor: 'transparent', color: '#1f2937' }),
                                        singleValue: (base) => ({ ...base, color: '#1f2937', fontSize: '13px' }),
                                        placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '13px' }),
                                        indicatorSeparator: () => ({ display: 'none' }),
                                        dropdownIndicator: (base) => ({ ...base, color: '#6b7280', padding: '0 8px' }),
                                        menu: (base) => ({ ...base, borderRadius: '8px', boxShadow: '0 6px 16px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', zIndex: 9999 }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '13px',
                                            backgroundColor: state.isSelected ? '#1a7d3e' : state.isFocused ? '#f0fdf4' : 'transparent',
                                            color: state.isSelected ? '#fff' : '#1f2937',
                                            cursor: 'pointer',
                                        }),
                                    }}
                                />
                            </>
                        )}
                    </div>

                    {selectedType === 'new' && (
                        <>
                            {Array.isArray(conditions) &&
                                conditions.map((cond, index) => (
                                    <div key={index} className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {index === 0 ? 'if' : 'and'}
                                        </span>

                                        <AppSelect portal
                                            value={cond.field}
                                            onChange={(e) => updateConditionField(index, e.target.value)}
                                            placeholder="Select a condition..."
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={conditionOptions.filter(
                                                (opt) => !selectedIsFields.includes(opt.value) || cond.field === opt.value
                                            )}
                                        />

                                        <AppSelect portal
                                            value={cond.operator}
                                            onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                            options={operatorOptions}
                                        />

                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded px-3 py-2 bg-white"
                                            style={{ flex: 1, minWidth: '150px', height: '38px', fontSize: '13px' }}
                                            value={cond.value}
                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                        />

                                        {conditions.length > 1 && (
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}

                            <div>
                                <button
                                    type="button"
                                    onClick={addCondition}
                                    className="automation-add-btn"
                                >
                                    <FiPlus size={13} />
                                    Add condition
                                </button>
                            </div>
                            <div>
                                {actionRows.map((row, i) => (
                                    <div key={i} className="flex items-start gap-3 mb-2 mt-4">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {i == 0 ? 'then' : ' and'}
                                        </span>

                                        {i == 0 ? (
                                            <>
                                                <div className="flex items-start gap-3" style={{ flex: 1 }}>
                                                    <div className="flex flex-col" style={{ flex: '0 0 200px' }}>
                                                        <AppSelect portal
                                                            value="move_to_board"
                                                            disabled
                                                            style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                                            options={[{ value: 'move_to_board', label: 'move it to the board' }]}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col" style={{ flex: '0 0 180px' }}>
                                                        <AppSelect portal
                                                            value={row.boardId || ''}
                                                            onChange={(e) => {
                                                                updateAction(i, e.target.value);
                                                                handleBoardChange(e.target.value);
                                                            }}
                                                            placeholder="Choose a board..."
                                                            error={!!boardError}
                                                            style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                                            options={boardName || []}
                                                        />

                                                        {boardError && (
                                                            <div className="h-5">
                                                                <p className="text-red-500 text-sm mt-1">
                                                                    {boardError}
                                                                </p>
                                                            </div>

                                                        )}
                                                    </div>

                                                    <div className="flex flex-col" style={{ flex: 1, minWidth: '150px' }}>
                                                        <AppSelect portal
                                                            value={row.entityId || ''}
                                                            onChange={(e) => updateBoardList(i, e.target.value)}
                                                            placeholder="Choose a list..."
                                                            style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                                            options={targetListOptions(row.boardId, row.entityId)}
                                                        />
                                                        {processOf(row.boardId) && (
                                                            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                                                                This board has a ticket process: only the lists a ticket may go to are shown.
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <AppSelect portal
                                                value={row.action}
                                                onChange={(e) => updateAction(i, e.target.value)}
                                                placeholder="Select Action"
                                                style={{ height: '38px', fontSize: '13px', minWidth: '200px', flex: 1 }}
                                                options={(i === 1
                                                    ? availableActions.filter((item) => {
                                                        if (!selectedFirstAction) return true;
                                                        const firstGroup = ['assignTo', 'assignToRoundRobin', 'unassign'];
                                                        const secondGroup = ['markComplete'];
                                                        if (firstGroup.includes(selectedFirstAction)) return item.value !== selectedFirstAction;
                                                        if (secondGroup.includes(selectedFirstAction)) return !secondGroup.includes(item.value);
                                                        return true;
                                                    })
                                                    : availableActions
                                                ).filter((action) => !lastTwoSelected.includes(action.value) || row.action === action.value)}
                                            />
                                        )}




                                        {showUserSelectFor.includes(row.action) &&
                                            (row.action === 'assignToRoundRobin' ? (
                                                <Select
                                                    isMulti
                                                    options={getOptionsForRow(row)}
                                                    placeholder="Select users"
                                                    isDisabled={isBoardUsersLoadingForRow(row)}
                                                    value={row.users || []}
                                                    onChange={(selected) => updateUser(i, selected, true)}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    components={{ Option: CheckboxOption }}
                                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1, minWidth: '200px', fontSize: '13px'}),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        control: (base) => ({
                                                            ...base,
                                                            // minHeight: '38px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #d1d5db',
                                                            boxShadow: 'none',
                                                            outline: 'none',
                                                            backgroundColor: '#fff',
                                                            '&:hover': { borderColor: '#d1d5db' },
                                                            '&:focus-within': { border: '1px solid #d1d5db', boxShadow: 'none' },
                                                        }),
                                                        valueContainer: (base) => ({ ...base, padding: '2px 8px', gap: '4px' }),
                                                        multiValue: (base) => ({ ...base, backgroundColor: '#f0fdf4', borderRadius: '4px' }),
                                                        multiValueLabel: (base) => ({ ...base, color: '#1a7d3e', fontSize: '12px', fontWeight: 500 }),
                                                        multiValueRemove: (base) => ({ ...base, color: '#1a7d3e', ':hover': { backgroundColor: '#dcfce7', color: '#166534' } }),
                                                        indicatorSeparator: () => ({ display: 'none' }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, caretColor: 'transparent' }),
                                                        // placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '13px' }),
                                                        menu: (base) => ({ ...base, borderRadius: '8px', boxShadow: '0 6px 16px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', zIndex: 9999 }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '13px',
                                                            backgroundColor: state.isSelected
                                                                ? '#f0fdf4'
                                                                : state.isFocused
                                                                    ? '#f5faf6'
                                                                    : 'transparent',
                                                            color: '#1f2937',
                                                            // cursor: 'pointer',
                                                            padding: '8px 12px',
                                                        }),
                                                    }}
                                                />
                                            ) : row.action === "assignTo" ? (
                                                <AppSelect portal
                                                    value={row.user || ''}
                                                    onChange={(e) => updateUser(i, e.target.value)}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Select user'}
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '240px',  cursor: 'pointer', caretColor: 'transparent' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                            ) : row.action === "setEmailLabel" ? (
                                                <AppSelect portal
                                                    value={row.user && row.user.name ? JSON.stringify({ parentId: row.user.parentId || null, childId: row.user.id || null, name: row.user.name }) : ''}
                                                    onChange={(e) => {handleLabelChange(i, e.target.value) }}
                                                    placeholder="Select label"
                                                    style={{ flex: 1, minWidth: '240px', height: '38px', fontSize: '13px', cursor: 'pointer', caretColor: 'transparent' }}
                                                    options={filteredOptions}
                                                />
                                            )
                                                : row.action === 'setCustomProperty' ? (
                                                    <>
                                                        <AppSelect portal
                                                            value={row.propertyId || row.customProperty || ''}
                                                            onChange={(e) => handlePropertySelect(i, e.target.value)}
                                                            placeholder="Select property"
                                                            style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '200px',  }}
                                                            options={customPropertyOptions}
                                                        />
                                                        <div className="flex-1" style={{ minWidth: '260px' }}>
                                                            {customFieldLoadingByRow[i] ? (
                                                                <p className="text-sm text-gray-500">Loading fields...</p>
                                                            ) : customFieldErrorByRow[i] ? (
                                                                <p className="text-sm text-red-500">{customFieldErrorByRow[i]}</p>
                                                            ) : Array.isArray(customFieldOptionsByRow[i]) && customFieldOptionsByRow[i].length > 0 ? (

                                                                <>


                                                                    <AutomationStatusDropdown idx={i} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                        setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                            handleUpdatedCustomField
                                                                        } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />

                                                                </>
                                                            ) : null}
                                                        </div>
                                                        {renderConflictOption(i)}{renderActionChecklistSection(i)}
                                                    </>
                                                ) : null



                                            )}




                                        {i > 0 && (
                                            <button
                                                onClick={() => {
                                                    const updated = [...actionRows];
                                                    updated.splice(i, 1);
                                                    setActionRows(updated);
                                                }}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                                title="Remove action"
                                                type="button"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}

                                {!shouldHideAddButton && (
                                    <button
                                        onClick={addActionRow}
                                        className="automation-add-btn"
                                        type="button"
                                    >
                                        + Add action
                                    </button>
                                )}

                                <div className="mt-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={showChecklist}
                                            onChange={(e) => setShowChecklist(e.target.checked)}
                                            style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                        />
                                        Do you want to add a checklist?
                                    </label>
                                    {showChecklist && (
                                        <div className="mt-2">
                                            <div className="font-medium text-gray-700 mb-1">Task Checklist</div>
                                            {renderChecklistBuilder('default')}
                                            <label className="flex items-center gap-2 mt-3 text-sm text-gray-700" style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={checklistMandatory}
                                                    onChange={(e) => setChecklistMandatory(e.target.checked)}
                                                    style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                                />
                                                Is this checklist mandatory? (the ticket can only be moved to another list once every item is checked)
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {duplicateMsg && (
                        <div className="flex items-center gap-3 mt-2">
                            <span className="font-medium text-gray-700 w-[60px]"></span>
                            <div className="text-red-500 text-sm bg-red-50 border border-red-200 rounded px-3 py-2 w-90">
                                ⚠️ {duplicateMsg}
                            </div>
                        </div>
                    )}

                    {selectedType === 'new' && (
                        <div className="mt-6 border-t pt-4">
                            <div className="font-bold text-lg mb-2">Advanced options</div>
                            <div className="flex flex-col gap-3">
                                <label className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={!skipInbox}
                                        onChange={(e) => setSkipInbox(!e.target.checked)}
                                        style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                    />
                                    New emails should skip the inbox
                                </label>
                                <label className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={skipReplies}
                                        onChange={(e) => setSkipReplies(e.target.checked)}
                                        style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                    />
                                    Replies to existing conversations already on the board should skip the inbox
                                </label>
                                <label className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={runOnExistingEmails}
                                        onChange={(e) => setRunOnExistingEmails(e.target.checked)}
                                        style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                    />

                                    Run this automation on existing emails in the Inbox, going back

                                    <AppSelect portal
                                        value={String(days)}
                                        onChange={(e) => setDays(e.target.value)}
                                        style={{ height: '30px', fontSize: '13px', minWidth: '90px' }}
                                        options={[
                                            ...Array.from({ length: 10 }, (_, idx) => ({
                                                value: String(idx + 1),
                                                label: `${idx + 1} day${idx + 1 > 1 ? 's' : ''}`,
                                            })),
                                            { value: '365', label: '1 year' },
                                        ]}
                                    />
                                </label>


                            </div>
                        </div>
                    )}










                    {selectedType == 'itemAdded' && (
                        <>
                            <div className="flex items-center gap-3 mb-1">
                                <span className="font-medium text-gray-700 w-[60px]">if</span>
                                <AppSelect portal
                                    value="the_board"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                    options={[{ value: 'the_board', label: 'the board' }]}
                                />
                                <AppSelect portal
                                    value="is"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                    options={[{ value: 'is', label: 'is' }]}
                                />
                                <div className="flex flex-col items-start gap-1" style={{ flex: 1 }}>
                                    <AppSelect portal
                                        value={boardSelect}
                                        onChange={(e) => handleBoardChange(e.target.value)}
                                        placeholder="Choose a board..."
                                        style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                        options={boardName || []}
                                    />
                                </div>
                            </div>

                            {Array.isArray(conditions) &&
                                conditions.map((cond, index) => (
                                    <div key={index} className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">and</span>
                                        <AppSelect portal
                                            value={cond.field}
                                            onChange={(e) => updateConditionField(index, e.target.value)}
                                            placeholder="choose an option..."
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={completedConditionOptions.filter(
                                                (opt) => !selectedIsFields.includes(opt.value) || cond.field === opt.value
                                            )}
                                        />

                                        <AppSelect portal
                                            value={cond.operator}
                                            onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                            options={operatorOptions}
                                        />

                                        {cond?.field === 'assignee' && (
                                            <AppSelect portal
                                                value={cond.value || ''}
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                                placeholder="Choose user..."
                                                style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                                options={(boardUserData || []).map(item => ({ value: item.id, label: item.name }))}
                                            />
                                        )}
                                        {(cond?.field === 'title' ||
                                            cond?.field === 'sender' ||
                                            cond?.field === 'recipient') && (
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                    style={{ flex: 1, minWidth: '150px', height: '38px', fontSize: '13px' }}
                                                    value={cond.value}
                                                    placeholder="specify..."
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                />
                                            )}
                                        {cond.field === 'listName' && (
                                            <AppSelect portal
                                                value={cond.value || ''}
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                                placeholder="Choose a list..."
                                                style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                                options={(selectedBoardColumn || []).map(item => ({ value: item.id, label: item.coloum }))}
                                            />
                                        )}

                                        {conditions.length > 1 && (
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}

                            <div>
                                <button
                                    type="button"
                                    onClick={addCondition}
                                    className="automation-add-btn"
                                >
                                    <FiPlus size={13} />
                                    Add condition
                                </button>
                            </div>

                            <div>
                                {actionRows.map((row, index) => (
                                    <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {index === 0 ? 'Then' : 'and'}
                                        </span>

                                        <AppSelect portal
                                            value={row.action}
                                            onChange={(e) => updateAction(index, e.target.value)}
                                            placeholder="Select Action"
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={conditionThenOption}
                                        />


                                        {showUserSelectFor.includes(row.action) &&
                                            (row.action === 'assignToRoundRobin' ? (
                                                <Select
                                                    isMulti
                                                    options={getOptionsForRow(row)}
                                                    placeholder="Select users"
                                                    isDisabled={isBoardUsersLoadingForRow(row)}
                                                    value={row.users || []}
                                                    onChange={(selected) => updateUser(index, selected, true)}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    components={{ Option: CheckboxOption }}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1, minWidth: '260px', maxWidth: '100%' }),
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '38px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #d1d5db',
                                                            boxShadow: 'none',
                                                            outline: 'none',
                                                            backgroundColor: '#fff',
                                                            '&:hover': { borderColor: '#d1d5db' },
                                                            '&:focus-within': { border: '1px solid #d1d5db', boxShadow: 'none' },
                                                        }),
                                                        valueContainer: (base) => ({ ...base, padding: '2px 8px', gap: '4px' }),
                                                        indicatorSeparator: () => ({ display: 'none' }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: 'transparent', caretColor: 'transparent', cursor: 'default' }),
                                                        placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '13px' }),
                                                        menu: (base) => ({ ...base, borderRadius: '8px', boxShadow: '0 6px 16px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', zIndex: 9999 }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '13px',
                                                            backgroundColor: state.isSelected ? '#f0fdf4' : state.isFocused ? '#f5faf6' : 'transparent',
                                                            color: '#1f2937',
                                                            cursor: 'pointer',
                                                            padding: '8px 12px',
                                                        }),
                                                    }}
                                                />
                                            ) : row.action === "assignTo" ? (
                                                <AppSelect portal
                                                    value={row.user || ''}
                                                    onChange={(e) => updateUser(index, e.target.value)}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Select user'}
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '240px', cursor: 'pointer', caretColor: 'transparent' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                            ) : row.action === "setEmailLabel" ? (
                                                <AppSelect portal
                                                    value={row.user && row.user.name ? JSON.stringify({ parentId: row.user.parentId || null, childId: row.user.id || null, name: row.user.name }) : ''}
                                                    onChange={(e) => { handleLabelChange(index, e.target.value) }}
                                                    placeholder="Select label"
                                                    style={{ flex: 1, minWidth: '240px', height: '38px', fontSize: '13px', cursor: 'pointer', caretColor: 'transparent' }}
                                                    options={filteredOptions}
                                                />
                                            ) : null
                                            )}

                                        {row.action === 'setCustomProperty' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.propertyId || row.customProperty}
                                                    onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                    placeholder="Select property"
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '200px' }}
                                                    options={customPropertyOptions}
                                                />
                                                <div className="flex-1" style={{ minWidth: '260px' }}>
                                                    {customFieldLoadingByRow[index] ? (
                                                        <p className="text-sm text-gray-500">Loading fields...</p>
                                                    ) : customFieldErrorByRow[index] ? (
                                                        <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                    ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                        <>
                                                            <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                    handleUpdatedCustomField
                                                                } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                        </>
                                                    ) : null}
                                                </div>
                                                {renderConflictOption(index)}{renderActionChecklistSection(index)}
                                            </>)}

                                        {row.action === 'createOnList' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.boardId || ''}
                                                    onChange={(e) => {
                                                        updateAction(index, e.target.value);
                                                        getSELECTED_BOARD(e.target.value);
                                                    }}
                                                    placeholder="Choose a board..."
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={boardName}
                                                />

                                                <AppSelect portal
                                                    value={row.entityId || ''}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder="Choose a list..."
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                                    options={targetListOptions(row.boardId, row.entityId)}
                                                />
                                                {processOf(row.boardId) && (
                                                    <div style={{ flexBasis: '100%', fontSize: '12px', color: '#6b7280' }}>
                                                        This board has a ticket process: only the lists a ticket may go to are shown.
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {renderDirectionOption(index)}

                                        {actionRows.length > 1 && (
                                            <button
                                                onClick={() => {
                                                    const updated = [...actionRows];
                                                    updated.splice(index, 1);
                                                    setActionRows(updated);
                                                }}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                                title="Remove action"
                                                type="button"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}


                                <button
                                    onClick={addActionRow}
                                    className="automation-add-btn"
                                    type="button"
                                >
                                    + Add action
                                </button>

                                <div className="mt-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={showChecklist}
                                            onChange={(e) => setShowChecklist(e.target.checked)}
                                            style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                        />
                                        Do you want to add a checklist?
                                    </label>
                                    {showChecklist && (
                                        <div className="mt-2">
                                            <div className="font-medium text-gray-700 mb-1">Task Checklist</div>
                                            {renderChecklistBuilder('default')}
                                            <label className="flex items-center gap-2 mt-3 text-sm text-gray-700" style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={checklistMandatory}
                                                    onChange={(e) => setChecklistMandatory(e.target.checked)}
                                                    style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                                />
                                                Is this checklist mandatory? (the ticket can only be moved to another list once every item is checked)
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {selectedType === 'noReplyToCustomer' && (
                        <>
                            <div className="flex items-center gap-3 mb-1">
                                <span className="font-medium text-gray-700 w-[60px]">if</span>
                                <AppSelect portal
                                    value="the_board"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                    options={[{ value: 'the_board', label: 'the board' }]}
                                />
                                <AppSelect portal
                                    value="is"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                    options={[{ value: 'is', label: 'is' }]}
                                />
                                <div className="flex flex-col items-start gap-1" style={{ flex: 1 }}>
                                    <AppSelect portal
                                        value={boardSelect}
                                        onChange={(e) => handleBoardChange(e.target.value)}
                                        placeholder="Choose a board..."
                                        style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                        options={boardName || []}
                                    />
                                </div>
                            </div>

                            {conditions.map((cond, index) => (
                                <div key={index} className="flex items-center gap-3 mb-1">
                                    <span className="font-medium text-gray-700 w-[60px]">and</span>

                                    <AppSelect portal
                                        value={cond.field}
                                        onChange={(e) => updateConditionField(index, e.target.value)}
                                        placeholder="choose an option..."
                                        style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                        options={(index === 0
                                            ? [{ label: 'the customer has been waiting', value: 'customerWaiting' }]
                                            : ConditionOptions
                                        ).filter(
                                            (opt) => !selectedIsFields.includes(opt.value) || cond.field === opt.value
                                        )}
                                    />

                                    <AppSelect portal
                                        value={cond.operator}
                                        onChange={(e) => updateConditionOperator(index, e.target.value)}
                                        style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                        options={cond.field === 'assignee'
                                            ? [{ label: 'is', value: 'equals' }]
                                            : index === 0
                                                ? no_reply_to_customer
                                                : operatorOptions
                                        }
                                    />

                                    {index === 0 && (
                                        <div className="flex flex-col" style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                className={`border rounded px-3 py-2 bg-white ${cond.operator === 'moreThanMins' &&
                                                    parseInt(cond.value) < 2 &&
                                                    cond.value !== ''
                                                    ? 'border-red-500'
                                                    : 'border-gray-300'
                                                    }`}
                                                value={cond.value}
                                                min="2"
                                                placeholder="specify...."
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                            />
                                            {cond.operator === 'moreThanMins' &&
                                                parseInt(cond.value) < 2 &&
                                                cond.value !== '' && (
                                                    <span className="text-xs mt-1 text-red-500">
                                                        Error: Minutes must be at least 15 for SLA alerts
                                                    </span>
                                                )}
                                        </div>
                                    )}

                                    {cond?.field === 'assignee' && (
                                        <AppSelect portal
                                            value={cond.value}
                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                            placeholder="Choose user..."
                                            style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                            options={(boardUserData || []).map(item => ({ value: item.id, label: item.name }))}
                                        />
                                    )}
                                    {(cond?.field === 'title' ||
                                        cond?.field === 'sender' ||
                                        cond?.field === 'recipient') && (
                                            <input
                                                type="text"
                                                className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                style={{ flex: 1, minWidth: '150px', height: '38px', fontSize: '13px' }}
                                                value={cond.value}
                                                placeholder="specify..."
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                            />
                                        )}
                                    {cond.field === 'listName' && (
                                        <AppSelect portal
                                            value={cond.value || ''}
                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                            placeholder="Choose a list..."
                                            style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                            options={selectedBoardColumn.map(item => ({ value: item.id, label: item.coloum }))}
                                        />
                                    )}
                                    <button
                                        onClick={() => removeCondition(index)}
                                        className="text-red-500 fonst-bold text-xl px-2"
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}

                            <div>
                                <button
                                    type="button"
                                    onClick={addCondition}
                                    className="automation-add-btn"
                                >
                                    <FiPlus size={13} />
                                    Add condition
                                </button>
                            </div>

                            <div>
                                {actionRows.map((row, index) => (
                                    <div key={index} className="flex  gap-3 mb-2 ">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {index === 0 ? 'Then' : 'and'}
                                        </span>

                                        <AppSelect portal
                                            value={row.action}
                                            onChange={(e) => updateAction(index, e.target.value)}
                                            placeholder="Select Action"
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={no_reply_then_condition}
                                        />
                                        {row.action === 'setSlaAlertTag' && (
                                            <>
                                                <Select
                                                    isMulti
                                                    isSearchable={false}
                                                    closeMenuOnSelect={false}
                                                    options={formattedOptions}
                                                    value={formattedOptions.filter((item) =>
                                                        (row.entityId || []).includes(item.value),
                                                    )}
                                                    onChange={(selectedOptions) =>
                                                        updateBoardList(
                                                            index,
                                                            selectedOptions.map((opt) => opt.value),
                                                        )
                                                    }
                                                    placeholder="Choose SLA alerts..."
                                                    styles={{ ...customStyles, container: (base) => ({ ...base, flex: 1, minWidth: '200px', fontSize: '13px' }) }}
                                                    components={{
                                                        MultiValue,
                                                        MultiValueRemove: () => null,
                                                        Option,
                                                    }}
                                                />
                                            </>
                                        )}
                                        {

                                            row.action === 'setEmailLabel' && (
                                                <AppSelect portal
                                                    value={row.user && row.user.name ? JSON.stringify({ parentId: row.user.parentId || null, childId: row.user.id || null, name: row.user.name }) : ''}
                                                    onChange={(e) => {handleLabelChange(index, e.target.value) }}
                                                    placeholder="Select label"
                                                    style={{ flex: 1, minWidth: '200px', height: '38px', fontSize: '13px', cursor: 'pointer', caretColor: 'transparent' }}
                                                    options={filteredOptions}
                                                />

                                            )


                                        }

                                        {row.action === 'setCustomProperty' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.propertyId || row.customProperty}
                                                    onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                    placeholder="Select property"
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '200px' }}
                                                    options={customPropertyOptions}
                                                />
                                                <div className="flex-1" style={{ minWidth: '260px' }}>
                                                    {customFieldLoadingByRow[index] ? (
                                                        <p className="text-sm text-gray-500">Loading fields...</p>
                                                    ) : customFieldErrorByRow[index] ? (
                                                        <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                    ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                        <>
                                                            <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                    handleUpdatedCustomField
                                                                } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                        </>
                                                    ) : null}
                                                </div>
                                                {renderConflictOption(index)}{renderActionChecklistSection(index)}
                                            </>)}

                                        {row.action === 'sendOverdueAlert' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.entityId}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm  text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="🔥Overdue - Customer is waiting for a reply."
                                                        style={{ background: 'transparent' }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendUpcomingAlert' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.user}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px', height: 'fit-content' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="⚡Upcoming soon - Don’t forget"
                                                        style={{ background: 'transparent' }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendNotificationTo' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.user}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="Issue escalated to you"
                                                        style={{ background: 'transparent' }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendEmailToCustomer' && (
                                            <div className="w-full flex flex-col gap-2" style={{ flexBasis: '100%' }}>
                                                <div className="flex items-center gap-2 flex-wrap">
                                                    <AppSelect portal
                                                        value={row.templateId}
                                                        onChange={(e) => updateTemplateId(index, e.target.value)}
                                                        placeholder="Select template"
                                                        style={{ height: '38px', fontSize: '13px', minWidth: '240px' }}
                                                        options={templateOptions}
                                                    />
                                                    <AppSelect portal
                                                        value={row.language}
                                                        onChange={(e) => applyTemplateToRow(index, row.templateId, e.target.value)}
                                                        placeholder="Language"
                                                        disabled={!row.templateId}
                                                        style={{ height: '38px', fontSize: '13px', minWidth: '160px' }}
                                                        options={getTemplateLanguageOptions(row.templateId)}
                                                    />
                                                    {row.language === AUTO_LANGUAGE && (
                                                        <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            Sent in the language the customer writes in (English when unknown). Pick a language to send the text below as edited.
                                                        </span>
                                                    )}
                                                </div>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white text-sm w-full"
                                                    placeholder="Subject"
                                                    value={row.subject || ''}
                                                    onChange={(e) => updateEmailField(index, 'subject', e.target.value)}
                                                />
                                                <div className="w-full bg-white">
                                                    <EditorComponent
                                                        key={`email-body-${index}`}
                                                        selectedPrevData={{ templateData: row.body || '' }}
                                                        textAreaValue={row.body || ''}
                                                        handleEditorChange={(data) => updateEmailField(index, 'body', data)}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {row.action === 'sendFollowUpToCustomer' && (
                                            <>
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="Create Follow-up Reminder"
                                                        style={{ background: 'transparent' }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {actionRows.length > 1 && (
                                            <button
                                                onClick={() => {
                                                    const updated = [...actionRows];
                                                    updated.splice(index, 1);
                                                    setActionRows(updated);
                                                }}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                                title="Remove action"
                                                type="button"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}


                                <button
                                    onClick={addActionRow}
                                    className="automation-add-btn"
                                    type="button"
                                >
                                    + Add action
                                </button>

                                <div className="mt-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={showChecklist}
                                            onChange={(e) => setShowChecklist(e.target.checked)}
                                            style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                        />
                                        Do you want to add a checklist?
                                    </label>
                                    {showChecklist && (
                                        <div className="mt-2">
                                            <div className="font-medium text-gray-700 mb-1">Task Checklist</div>
                                            {renderChecklistBuilder('default')}
                                            <label className="flex items-center gap-2 mt-3 text-sm text-gray-700" style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={checklistMandatory}
                                                    onChange={(e) => setChecklistMandatory(e.target.checked)}
                                                    style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                                />
                                                Is this checklist mandatory? (the ticket can only be moved to another list once every item is checked)
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {selectedType === 'noReplyFromCustomer' && (
                        <>
                            <div className="flex items-center gap-3 mb-1">
                                <span className="font-medium text-gray-700 w-[60px]">if</span>
                                <AppSelect portal
                                    value="the_board"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                    options={[{ value: 'the_board', label: 'the board' }]}
                                />
                                <AppSelect portal
                                    value="is"
                                    disabled
                                    style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                    options={[{ value: 'is', label: 'is' }]}
                                />
                                <div className="flex flex-col items-start gap-1" style={{ flex: 1 }}>
                                    <AppSelect portal
                                        value={boardSelect}
                                        onChange={(e) => handleBoardChange(e.target.value)}
                                        placeholder="Choose a board..."
                                        style={{ height: '38px', fontSize: '13px', width: '100%' }}
                                        options={boardName || []}
                                    />
                                </div>
                            </div>

                            {conditions.map((cond, index) => (
                                <div key={index} className="flex items-center gap-3 mb-1">
                                    <span className="font-medium text-gray-700 w-[60px]">and</span>

                                    <AppSelect portal
                                        value={cond.field}
                                        onChange={(e) => updateConditionField(index, e.target.value)}
                                        placeholder="choose an option..."
                                        style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                        options={(index === 0
                                            ? [{ label: 'the team has been waiting', value: 'customerNotResponding' }]
                                            : ConditionOptions
                                        ).filter(
                                            (opt) => !selectedIsFields.includes(opt.value) || cond.field === opt.value
                                        )}
                                    />

                                    <AppSelect portal
                                        value={cond.operator}
                                        onChange={(e) => updateConditionOperator(index, e.target.value)}
                                        style={{ height: '38px', fontSize: '13px', minWidth: '130px' }}
                                        options={cond.field === 'assignee'
                                            ? [{ label: 'is', value: 'equals' }]
                                            : index === 0
                                                ? no_reply_to_customer
                                                : operatorOptions
                                        }
                                    />

                                    {index === 0 && (
                                        <div className="flex flex-col" style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                className={`border rounded px-3 py-2 bg-white ${cond.operator === 'moreThanMins' &&
                                                    parseInt(cond.value) < 2 &&
                                                    cond.value !== ''
                                                    ? 'border-red-500'
                                                    : 'border-gray-300'
                                                    }`}
                                                value={cond.value}
                                                min="2"
                                                placeholder="specify...."
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                            />
                                            {cond.operator === 'moreThanMins' &&
                                                parseInt(cond.value) < 2 &&
                                                cond.value !== '' && (
                                                    <span className="text-xs mt-1 text-red-500">
                                                        Error: Minutes must be at least 15 for SLA alerts
                                                    </span>
                                                )}
                                        </div>
                                    )}
                                    {cond?.field === 'assignee' && (
                                        <AppSelect portal
                                            value={cond.value}
                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                            placeholder="Choose user..."
                                            style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                            options={(boardUserData || []).map(item => ({ value: item.id, label: item.name }))}
                                        />
                                    )}
                                    {(cond?.field === 'title' ||
                                        cond?.field === 'sender' ||
                                        cond?.field === 'recipient') && (
                                            <input
                                                type="text"
                                                className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                style={{ flex: 1, minWidth: '150px', height: '38px', fontSize: '13px' }}
                                                value={cond.value}
                                                placeholder="specify..."
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                            />
                                        )}
                                    {cond.field === 'listName' && (
                                        <AppSelect portal
                                            value={cond.value || ''}
                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                            placeholder="Choose a list..."
                                            style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '150px' }}
                                            options={selectedBoardColumn.map(item => ({ value: item.id, label: item.coloum }))}
                                        />
                                    )}
                                    <button
                                        onClick={() => removeCondition(index)}
                                        className="text-red-500 fonst-bold text-xl px-2"
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}

                            <div>
                                <button
                                    type="button"
                                    onClick={addCondition}
                                    className="automation-add-btn"
                                >
                                    <FiPlus size={13} />
                                    Add condition
                                </button>
                            </div>

                            <div>
                                {actionRows.map((row, index) => (
                                    <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {index === 0 ? 'Then' : 'and'}
                                        </span>

                                        <AppSelect portal
                                            value={row.action}
                                            onChange={(e) => updateAction(index, e.target.value)}
                                            placeholder="Select Action"
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={no_reply_then_condition}
                                        />
                                        {row.action === 'setSlaAlertTag' && (
                                            <>
                                                <Select
                                                    isMulti
                                                    isSearchable={false}
                                                    closeMenuOnSelect={false}
                                                    options={formattedOptions}
                                                    value={formattedOptions.filter((item) =>
                                                        (row.entityId || []).includes(item.value),
                                                    )}
                                                    onChange={(selectedOptions) =>
                                                        updateBoardList(
                                                            index,
                                                            selectedOptions.map((opt) => opt.value),
                                                        )
                                                    }
                                                    placeholder="Choose SLA alerts..."
                                                    styles={{ ...customStyles, container: (base) => ({ ...base, flex: 1, minWidth: '200px', fontSize: '13px' }) }}
                                                    components={{
                                                        MultiValue,
                                                        MultiValueRemove: () => null,
                                                        Option,
                                                    }}
                                                />
                                            </>
                                        )}


                                        {row.action === 'setEmailLabel' && (
                                            <AppSelect portal
                                                value={row.user && row.user.name ? JSON.stringify({ parentId: row.user.parentId || null, childId: row.user.id || null, name: row.user.name }) : ''}
                                                onChange={(e) => { handleLabelChange(index, e.target.value) }}
                                                placeholder="Select label"
                                                style={{ flex: 1, minWidth: '200px', height: '38px', fontSize: '13px', cursor: 'pointer', caretColor: 'transparent' }}
                                                options={filteredOptions}
                                            />
                                        )}
                                        {row.action === 'setCustomProperty' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.propertyId || row.customProperty}
                                                    onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                    placeholder="Select property"
                                                    style={{ height: '38px', fontSize: '13px', flex: 1, minWidth: '200px' }}
                                                    options={customPropertyOptions}
                                                />
                                                <div className="flex-1" style={{ minWidth: '260px' }}>
                                                    {customFieldLoadingByRow[index] ? (
                                                        <p className="text-sm text-gray-500">Loading fields...</p>
                                                    ) : customFieldErrorByRow[index] ? (
                                                        <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                    ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                        <>
                                                            <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                    handleUpdatedCustomField
                                                                } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                        </>
                                                    ) : null}
                                                </div>
                                                {renderConflictOption(index)}{renderActionChecklistSection(index)}
                                            </>)}

                                        {row.action === 'sendOverdueAlert' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.entityId}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="🔥Overdue - Customer is waiting for a reply."
                                                        style={{
                                                            paddingRight: '1rem',
                                                            background: 'transparent',
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendUpcomingAlert' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.entityId}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px', height: 'fit-content' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="⚡Upcoming soon - Don’t forget"
                                                        style={{
                                                            paddingRight: '1rem',
                                                            background: 'transparent',
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendNotificationTo' && (
                                            <>
                                                <AppSelect portal
                                                    value={row.entityId}
                                                    onChange={(e) => updateBoardList(index, e.target.value)}
                                                    placeholder={isBoardUsersLoadingForRow(row) ? 'Loading users...' : 'Assignee'}
                                                    disabled={isBoardUsersLoadingForRow(row)}
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                    options={getOptionsForRow(row)}
                                                />
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="Issue escalated to you"
                                                        style={{
                                                            paddingRight: '1rem',
                                                            background: 'transparent',
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {row.action === 'sendEmailToCustomer' && (
                                            <div className="w-full flex flex-col gap-2" style={{ flexBasis: '100%' }}>
                                                <div className="flex items-center gap-2 flex-wrap">
                                                    <AppSelect portal
                                                        value={row.templateId}
                                                        onChange={(e) => updateTemplateId(index, e.target.value)}
                                                        placeholder="Select template"
                                                        style={{ height: '38px', fontSize: '13px', minWidth: '240px' }}
                                                        options={templateOptions}
                                                    />
                                                    <AppSelect portal
                                                        value={row.language}
                                                        onChange={(e) => applyTemplateToRow(index, row.templateId, e.target.value)}
                                                        placeholder="Language"
                                                        disabled={!row.templateId}
                                                        style={{ height: '38px', fontSize: '13px', minWidth: '160px' }}
                                                        options={getTemplateLanguageOptions(row.templateId)}
                                                    />
                                                    {row.language === AUTO_LANGUAGE && (
                                                        <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            Sent in the language the customer writes in (English when unknown). Pick a language to send the text below as edited.
                                                        </span>
                                                    )}
                                                </div>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white text-sm w-full"
                                                    placeholder="Subject"
                                                    value={row.subject || ''}
                                                    onChange={(e) => updateEmailField(index, 'subject', e.target.value)}
                                                />
                                                <div className="w-full bg-white">
                                                    <EditorComponent
                                                        key={`email-body-${index}`}
                                                        selectedPrevData={{ templateData: row.body || '' }}
                                                        textAreaValue={row.body || ''}
                                                        handleEditorChange={(data) => updateEmailField(index, 'body', data)}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                                    1st follow-up: sent when the customer has not replied for the time above, counted from our last reply.
                                                    A customer reply stops the follow-ups; our next reply starts them again.
                                                </div>
                                                {(row.followUps || []).map((f, fi) => (
                                                    <div
                                                        key={fi}
                                                        className="flex flex-col gap-2"
                                                        style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px', background: '#fafafa' }}
                                                    >
                                                        <div className="flex items-center gap-2 flex-wrap">
                                                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#1a7d3e', minWidth: '110px' }}>
                                                                {FOLLOW_UP_NAMES[fi]}
                                                            </span>
                                                            <span className="text-sm text-gray-700">if still no reply</span>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                className="border border-gray-300 rounded px-3 py-2 bg-white text-sm"
                                                                style={{ width: '90px', height: '38px' }}
                                                                placeholder="e.g. 3"
                                                                value={f.after?.value ?? ''}
                                                                onChange={(e) => updateFollowUp(index, fi, { after: { ...f.after, value: e.target.value } })}
                                                            />
                                                            <AppSelect portal
                                                                value={f.after?.unit || 'days'}
                                                                onChange={(e) => updateFollowUp(index, fi, { after: { ...f.after, unit: e.target.value } })}
                                                                style={{ height: '38px', fontSize: '13px', minWidth: '110px' }}
                                                                options={FOLLOW_UP_UNITS}
                                                            />
                                                            <span className="text-sm text-gray-700">after the previous email</span>
                                                            <button
                                                                type="button"
                                                                title="Remove follow-up"
                                                                onClick={() => removeFollowUp(index, fi)}
                                                                className="text-red-500 fonst-bold text-xl px-2"
                                                                style={{ marginLeft: 'auto' }}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                        <div className="flex items-center gap-2 flex-wrap">
                                                            <AppSelect portal
                                                                value={f.templateId}
                                                                onChange={(e) => applyTemplateToFollowUp(index, fi, e.target.value, f.language)}
                                                                placeholder="Select template"
                                                                style={{ height: '38px', fontSize: '13px', minWidth: '240px' }}
                                                                options={templateOptions}
                                                            />
                                                            <AppSelect portal
                                                                value={f.language}
                                                                onChange={(e) => applyTemplateToFollowUp(index, fi, f.templateId, e.target.value)}
                                                                placeholder="Language"
                                                                disabled={!f.templateId}
                                                                style={{ height: '38px', fontSize: '13px', minWidth: '160px' }}
                                                                options={getTemplateLanguageOptions(f.templateId)}
                                                            />
                                                            {f.language === AUTO_LANGUAGE && (
                                                                <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                                                    Sent in the customer's language (English when unknown).
                                                                </span>
                                                            )}
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="border border-gray-300 rounded px-3 py-2 bg-white text-sm w-full"
                                                            placeholder="Subject"
                                                            value={f.subject || ''}
                                                            onChange={(e) => updateFollowUp(index, fi, { subject: e.target.value })}
                                                        />
                                                        <div className="w-full bg-white">
                                                            <EditorComponent
                                                                key={`follow-up-body-${index}-${fi}-${f.templateId}-${f.language}`}
                                                                selectedPrevData={{ templateData: f.body || '' }}
                                                                textAreaValue={f.body || ''}
                                                                handleEditorChange={(data) => updateFollowUp(index, fi, { body: data })}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                                {(row.followUps || []).length < FOLLOW_UP_NAMES.length && (
                                                    <div>
                                                        <button type="button" className="automation-add-btn" onClick={() => addFollowUp(index)}>
                                                            + Add {FOLLOW_UP_NAMES[(row.followUps || []).length]}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {row.action === 'sendFollowUpToCustomer' && (
                                            <>
                                                <div className="relative border border-gray-300 rounded px-3 py-2 bg-white" style={{ flex: 1, minWidth: '150px' }}>
                                                    <textarea
                                                        className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                        value={row.message}
                                                        onChange={(e) => updateMessage(index, e.target.value)}
                                                        placeholder="Create Follow-up Reminder"
                                                        style={{
                                                            paddingRight: '1rem',
                                                            background: 'transparent',
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {actionRows.length > 1 && (
                                            <button
                                                onClick={() => {
                                                    const updated = [...actionRows];
                                                    updated.splice(index, 1);
                                                    setActionRows(updated);
                                                }}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                                title="Remove action"
                                                type="button"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}


                                <button
                                    onClick={addActionRow}
                                    className="automation-add-btn"
                                    type="button"
                                >
                                    + Add action
                                </button>

                                <div className="mt-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={showChecklist}
                                            onChange={(e) => setShowChecklist(e.target.checked)}
                                            style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                        />
                                        Do you want to add a checklist?
                                    </label>
                                    {showChecklist && (
                                        <div className="mt-2">
                                            <div className="font-medium text-gray-700 mb-1">Task Checklist</div>
                                            {renderChecklistBuilder('default')}
                                            <label className="flex items-center gap-2 mt-3 text-sm text-gray-700" style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={checklistMandatory}
                                                    onChange={(e) => setChecklistMandatory(e.target.checked)}
                                                    style={{ accentColor: '#1a7d3e', width: '15px', height: '15px' }}
                                                />
                                                Is this checklist mandatory? (the ticket can only be moved to another list once every item is checked)
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {(selectedType === 'completed' ||
                        selectedType === 'reopened' ||
                        selectedType === 'customer' ||
                        selectedType === 'assigned') && (
                            <>
                                {conditions.map((cond, index) => (
                                    <div key={index} className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">
                                            {index === 0 ? 'if' : 'and'}
                                        </span>

                                        <AppSelect portal
                                            value={cond.field || (index === 0 ? 'board' : '')}
                                            placeholder="choose an option..."
                                            style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                            options={index === 0
                                                ? [{ label: 'the board', value: 'board' }]
                                                : selectedType === 'completed' || selectedType === 'assigned'
                                                    ? completedConditionOptions
                                                    : customPropertyThenOption
                                            }
                                        />

                                        <AppSelect portal
                                            value={cond.operator || (index === 0 ? 'is' : '')}
                                            style={{ height: '38px', fontSize: '13px', minWidth: '120px' }}
                                            options={index === 0
                                                ? [{ label: 'is', value: 'is' }]
                                                : operatorOptions
                                            }
                                        />

                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded px-3 py-2 bg-white"
                                        />

                                        {conditions.length > 0 && (
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 font-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}

                                <div>
                                    <button
                                        onClick={addCondition}
                                        className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                    >
                                        + Add condition
                                    </button>
                                </div>


                                <div className="flex items-center gap-3 mb-1 mt-4">
                                    <span className="font-medium text-gray-700 w-[60px]">Then</span>

                                    <AppSelect portal
                                        value=""
                                        style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                        options={conditionThenOption}
                                    />

                                    <AppSelect portal
                                        value={boardSelect}
                                        onChange={(e) => handleBoardChange(e.target.value)}
                                        placeholder="Choose a board..."
                                        style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                        options={boardName || []}
                                    />

                                    <AppSelect portal
                                        value={boardColumnSelect}
                                        onChange={(e) => setBoardColumnSelect(e.target.value)}
                                        placeholder="Choose a list..."
                                        style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                        options={targetListOptions(boardSelect, boardColumnSelect)}
                                    />
                                </div>
                                <div>
                                    {actionRows.map((row, i) => (
                                        <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                            <span className="font-medium text-gray-700 w-[60px]">and</span>
                                            <AppSelect portal
                                                value={row.action}
                                                onChange={(e) => updateAction(i, e.target.value)}
                                                placeholder="Select Action"
                                                style={{ height: '38px', fontSize: '13px', minWidth: '200px' }}
                                                options={i === 0 ? availableActions : availableActions.slice(3)}
                                            />
                                            {showUserSelectFor.includes(row.action) && (
                                                <AppSelect portal
                                                    value={row.user}
                                                    onChange={(e) => updateUser(i, e.target.value)}
                                                    placeholder="demo"
                                                    style={{ height: '38px', fontSize: '13px', minWidth: '160px' }}
                                                    options={(boardUserData || []).map(user => ({ value: user.id, label: user.name }))}
                                                />
                                            )}
                                            {row.action === 'setCustomProperty' && renderConflictOption(i)}{row.action === 'setCustomProperty' && renderActionChecklistSection(i)}
                                            <button
                                                onClick={() => {
                                                    const updated = [...actionRows];
                                                    updated.splice(i, 1);
                                                    setActionRows(updated);
                                                }}
                                                className="ml-2  w-8 h-8 flex items-center justify-center text-lg font-bold"
                                                title="Remove action"
                                                type="button"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                    {!shouldHideAddButton && (
                                        <button
                                            type="button"
                                            onClick={addActionRow}
                                            className="automation-add-btn"
                                        >
                                            <FiPlus size={13} />
                                            Add action
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                </div>
            </div>
        </AppModal>
    );
};

export default Automation;
